import React from 'react';
import { reduxForm } from 'redux-form';
import { Alert, Modal, Spinner, Table, Button, Nav, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Show } from 'Layout';
import { PageStatus } from 'enums';
import { AuthAPI, MasterDataAPI, SurveysAPI, PartnersAPI } from '../../API';
import Select from 'react-select';
import moment from 'moment';
import Swal from 'sweetalert2';
import { isArray } from 'lodash';
import { checkNumberValidation } from 'Helper/Validations';
import { ParentProjectTab } from './ParentProjectTab';
import { ChildSurveyTab } from './ChildSurveyTab';
import { PreScreeningSection } from './PreScreeningSection';
import { PartnersTab } from './PartnersTab';
import { SurveySamplesTab } from './SurveySamplesTab';
import {
  isPanelCountry, DEFAULT_CHILD_STATE, CHILD_OVERRIDABLE_FIELDS,
  ChildSurveyState,
} from './surveyConstants';
import { IN_DEFAULT_DISCLAIMER } from './indiaPollsDefaults';
import {
  childProjectNameParts, composeChildProjectName, normalizeChildProjectName,
} from './childProjectName';
import { logSubmitState } from '../../Utils/diagnoseUrlUpdate';
import { getSurveyDisplayName } from '../../Utils/surveyDisplayName';

export type FormValue = {
  name: string;
};

function replacePlaceholderWithAnchor(text: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  if (doc.querySelector('a')) return text;
  const placeholderRegex = /<((https?:\/\/)[^>]+)>/i;
  const match = text.match(placeholderRegex);
  if (match) {
    const anchorTag = `<a href="${match[1]}" target="_blank" style="color: orange;">${match[1]}</a>`;
    return text.replace(match[0], anchorTag);
  }
  return text;
}

const DEFAULT_DISCLAIMER = 'Disclaimer: Dear Respondent, Thank you for your continued patronage. Please note that your points will be awarded within 60 days of project closure. To serve you more, we request that you always keep your profile up to date. Your valuable profile is a guiding light for the Online Market Research Industry, please visit <a href="/" target="_blank" style="color: orange;">dataxing.com</a> to login and update your profile for a more rewarding journey ahead ! Thank you.';

class Form extends React.Component<any, any> {
  _isMounted = false;

  constructor(props: any) {
    super(props);
    this.state = {
      // UI state
      status: PageStatus.None,
      error: null,
      activeTab: 'parent',
      formType: 'NONE',
      // Pre-screening modal context: which child tab opened the modal
      // (null when modal is closed). Carries the active shortName so the
      // shared modal mutates childStates[shortName].details / submittedAnswerDets.
      activePreScreenChild: null,
      selectedPreScreenQueDet: {},

      // Dropdown data
      options: [],
      preScreenOptions: [],
      countries: [],
      clientOptions: [],
      pmData: [],

      // Blacklist
      blacklistSurvey: [],
      selectedSurveyOptionss: [],

      // Parent project fields
      projectName: '',
      // Parent's projectName when editing a CHILD directly (Form.props.id is a child
      // id and data.parentid is set). Backend getOne attaches data.parentProjectName
      // from the parent row; we hydrate into this field so the input-group's locked
      // prefix uses the true parent name instead of the child's own `${parent}_${cc}`
      // (which would double-stamp the country code). '' for parent edits and create.
      parentProjectName: '',
      projectId: '',
      company: '',
      companyLogo: '',
      description: '',
      pmName: '',
      // PM's users.id — the routing key for PM-targeted notifications
      // (surveys.pmId -> notifySurveyStakeholders). pmName stays as the
      // human-readable label; it is NOT a routing key.
      pmId: '',
      client: '',
      clientir: '',
      costPerInterview: 0,
      currency: '',
      publishDate: new Date().toISOString().split('T')[0],
      expiryDate: '',
      Newdateexpireset: '',
      surveyLength: 0,
      outlierCutoffTime: 0,
      validateStartEndIp: 'Y',
      validateCountry: 'Y',
      surveyUrlIdentifier: 'id',
      colorCode: '',
      description_one: '',
      description_two: '',
      description_three: '',
      description_four: '',
      isActive: true,
      isPaused: false,
      ipUnique: false,

      // Parent pre-screening removed — it is now per-country, owned by childStates.
      // totalQuestionQuotaCount is computed during answer-mapping inside the modal
      // (driven by the active child's selectedPreScreenQues) and used for the
      // "Pre-Screen Quota can't be greater than Client Quota" guard at submit.
      totalQuestionQuotaCount: 0,

      // Pre-screening modal state
      answersFields: [],
      questionQuotaPoints: 0,
      quotaPointAnswer: '',

      // Country selection
      selectedCountryOption: [],
      country: [],
      previousCountry: '',

      // Per-child state: { [shortName]: ChildSurveyState }
      childStates: {} as Record<string, ChildSurveyState>,

      // Legacy/edit
      data: '',
      groupClone: '',

      // Default parent-level values that children inherit
      ceggPoints: 0,
      overquota: 2,
      terminate: 2,
      qualityterminate: 0,
      userLimitCommitted: 0,
      userLimitCutoff: 0,
      IPollsQuotaLimit: 'N',
      pointAllocationType: 'Manual',
      surveyType: 'Test',
      whatsapp: 'N',
      email: 'N',
      sms: 'N',
      useUniqueLinks: false,
      url: '',
      testurl: '',
      name: '',
      disclaimer: DEFAULT_DISCLAIMER,
      deviceCompatibility: 'mobile,desktop,tablet',

      // Ask 4 — per-child unique-link upload outcomes from the most recent
      // create/update response, keyed by child survey id. Drives the inline
      // "X added, Y duplicates skipped" feedback under ChildSurveyTab's CSV
      // input. Empty {} on first mount; cleared/overwritten on each Save.
      lastUniqueLinksUploadResults: {} as Record<string, { total_in_csv: number; added: number; skipped_duplicates: number; error?: string }>,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.id) {
      // Run both fetches in parallel. The second-pass prescreener hydration
      // needs both the question pool (preScreenOptions) and the per-child
      // metadata (loaded into childStates by fetchChildSurveys via fetchDetails)
      // so we kick it off only after BOTH have settled — no arbitrary timeout.
      Promise.all([this.fetchDetails(), this.preScreenFetchList()])
        .then(() => {
          if (!this._isMounted) return;
          this.loadChildPreScreenOverrides();
        });
    } else {
      this.fetchList();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Edit-mode second pass: for each child survey, fetch its persisted prescreening
   * metadata via SurveysAPI.getOne(childId) and seed childStates[shortName] with
   * preQuestionsYN, selectedPreScreenQues, details, submittedAnswerDets so the
   * country tab renders the saved configuration.
   *
   * Skips children where prescreening is disabled (preQuestionsYN!=='Y') and
   * skips when the question pool hasn't loaded yet (preScreenOptions empty);
   * the pool is needed to project the persisted question_ids back into the
   * react-select option shape.
   */
  loadChildPreScreenOverrides = async () => {
    const id = this.props.id;
    if (!id) return;

    try {
      let children = await SurveysAPI.getChildSurveys(id);
      if (!this._isMounted) return;

      // Child-direct edit: this.props.id is a CHILD UUID, so getChildSurveys
      // returns []. Fall back to a single-element list pointing at the loaded
      // child itself so the same hydration code below seeds its picked
      // questions, qualifying answers, and master toggle.
      if ((!children || children.length === 0)) {
        const selfData: any = this.state.data || {};
        if (selfData && selfData.parentid && selfData.shortName) {
          children = [{
            id: selfData.id,
            shortName: selfData.shortName,
            country: selfData.country,
            preQuestionsYN: selfData.preQuestionsYN,
            overriddenFields: selfData.overriddenFields,
          }];
        } else {
          return;
        }
      }

      // Pool not loaded yet → bail; first child toggle-on will trigger preScreenFetchList
      // which calls back into this once options arrive.
      const pool: any[] = this.state.preScreenOptions || [];
      const optionByValue: Record<string, any> = {};
      pool.forEach((o: any) => { optionByValue[o.value] = o; });

      // Accumulate ONLY the per-child prescreen fields here. We deliberately do
      // NOT snapshot the whole childStates map up front and write it back at the
      // end — this method awaits getOne() per child, and during that async
      // window the user may edit Survey Status / Point Allocation / numeric
      // fields on a tab. A stale-snapshot write-back would silently clobber
      // those concurrent edits (Bug B). Instead we collect just the prescreen
      // results and merge them per-key against FRESH state inside a functional
      // setState below.
      const preScreenResults: Record<string, {
        preQuestionsYN: 'Y' | 'N';
        overriddenFields: string[];
        selectedPreScreenQues: any[];
        details: any[];
        submittedAnswerDets: string[];
      }> = {};
      let changed = false;

      for (const child of children) {
        // childStates is id-keyed; fall back to looking up by shortName in
        // case the same-modal-session pool fetch races with a re-keying.
        const key = child.id;
        // Read the current (fresh) entry only to seed defaults; the authoritative
        // merge happens in the functional setState at the end.
        if (!key || !this.state.childStates[key]) continue;
        const childPreScreen = child.preQuestionsYN === 'Y' ? 'Y' : 'N';
        const prev = this.state.childStates[key];

        // Default: reflect the persisted master toggle. Picked-question detail
        // requires a getOne() call to fetch the per-child metadata rows.
        let selectedPreScreenQues: any[] = prev.selectedPreScreenQues || [];
        let details: any[] = prev.details || [];
        let submittedAnswerDets: string[] = prev.submittedAnswerDets || [];

        if (childPreScreen === 'Y' && child.id && pool.length > 0) {
          try {
            const childData = await SurveysAPI.getOne(child.id);
            const surveyquestion = childData.surveyquestion || [];
            // Reconstruct selectedPreScreenQues in option shape, preserving DB order.
            //
            // IMPORTANT: keep TWO different views of the answers for each question:
            //   1. fullAnswerId — every option from DB with its mark/y|n flag intact.
            //      This is what gets written back to the wire (child.details[i].answerId)
            //      so a no-op save round-trips correctly. Dropping the unmarked options
            //      or the mark='y' field on save = matchAnswers terminates every panellist.
            //   2. selectedAnsArr — only the qualifying ('y') options, used by the table
            //      to render "Selected Answers" and by the SelectAnswer modal pre-checks.
            selectedPreScreenQues = surveyquestion
              .map((sq: any) => {
                const fullAnswerId = Array.isArray(sq.answerId) ? sq.answerId : [];
                // A saved pick can be missing from the pool (the pool is scoped
                // server-side). Rebuild its option from the saved row instead of
                // dropping it — dropping hides it here and the save then omits it.
                // answerId holds every option (mark 'y'|'n'), so its .answer
                // values are the full answer list the Select Answer modal needs.
                const opt = optionByValue[sq.question_id] || {
                  label: sq.question,
                  value: sq.question_id,
                  type: sq.type,
                  question: sq.question,
                  answers: fullAnswerId.map((a: any) => a && a.answer),
                  questionType: sq.questionType,
                  selectedAnsArr: [],
                  questionDisplayOrder: '',
                };
                const selectedAnsArr = fullAnswerId
                  .filter((a: any) => a && a.mark === 'y')
                  .map((a: any) => ({
                    answer: a.answer,
                    // Keep mark: the modal's `checked` predicate tests mark === 'y'.
                    mark: a.mark,
                    questionQuotaPoints: a.questionQuotaPoints || 0,
                    completeCount: a.completeCount != null ? a.completeCount : null,
                  }));
                return { ...opt, selectedAnsArr, fullAnswerId };
              });
            details = selectedPreScreenQues.map((opt: any) => ({
              id: opt.value, question: opt.question, questionType: opt.questionType,
              // Persist the FULL DB shape (with mark='y'|'n' on every option), not the
              // trimmed display projection. matchAnswers reads .answerId.filter(mark==='y'),
              // so the mark field must survive every round-trip.
              type: opt.type, answerId: opt.fullAnswerId,
            }));
            submittedAnswerDets = selectedPreScreenQues
              .filter((opt: any) => (opt.selectedAnsArr || []).length > 0)
              .map((opt: any) => opt.value);
          } catch (_e) { /* ignore individual child fetch errors */ }
        } else if (childPreScreen !== 'Y') {
          // Disabled in DB — clear any seeded picks.
          selectedPreScreenQues = [];
          details = [];
          submittedAnswerDets = [];
        }

        preScreenResults[key] = {
          preQuestionsYN: childPreScreen,
          overriddenFields: child.overriddenFields || prev.overriddenFields || [],
          selectedPreScreenQues,
          details,
          submittedAnswerDets,
        };
        changed = true;
      }

      if (changed && this._isMounted) {
        // Functional setState merges the prescreen results onto the LATEST
        // childStates (prev), so any surveyType / pointAllocationType / numeric
        // edits the user made while the getOne() calls were in flight survive.
        // We only touch the prescreen-specific keys per child — never the whole
        // map, never a stale snapshot.
        this.setState((prevState: any) => {
          const merged = { ...prevState.childStates };
          Object.keys(preScreenResults).forEach((key) => {
            // The child may have been removed from state mid-flight (rare); skip.
            if (!merged[key]) return;
            const r = preScreenResults[key];
            merged[key] = {
              ...merged[key],
              preQuestionsYN: r.preQuestionsYN,
              overriddenFields: r.overriddenFields,
              selectedPreScreenQues: r.selectedPreScreenQues,
              details: r.details,
              submittedAnswerDets: r.submittedAnswerDets,
              removedPreScreenQuestionIds: [],
            };
          });
          console.log('=== PRESCREEN FIX: Loaded per-child editor state ===',
            Object.entries(merged).map(([k, v]: [string, any]) => ({
              shortName: k,
              preQuestionsYN: v.preQuestionsYN,
              picked: (v.selectedPreScreenQues || []).length,
              mapped: (v.submittedAnswerDets || []).length,
            }))
          );
          return {
            childStates: merged,
            totalQuestionQuotaCount: this.recomputePrescreenQuotaCount(merged),
          };
        });
      }
    } catch (err: any) {
      console.error('loadChildPreScreenOverrides error:', err);
    }
  };

  // ==================== DATA FETCHING ====================

  fetchDetails(): Promise<void> {
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }); })
      .then(() => {
        if (!this.props.id) return Promise.reject(new Error('Invalid ID'));
        return SurveysAPI.getOne(this.props.id);
      })
      .then((respoData: any) => {
        if (!this._isMounted) return;
        let data = respoData.data;
        this.initializeValues(respoData);
        // Stash the per-child metadata payload so child-direct seeding (in
        // fetchChildSurveys) and downstream rehydration can read it without a
        // second getOne call. Important: respoData.surveyquestion is keyed off
        // this.props.id, so for a child-direct edit it already carries the
        // picked questions for that single child.
        return new Promise<void>((resolve) => {
          this.setState({
            data,
            status: PageStatus.Loaded,
            initialSurveyQuestion: Array.isArray(respoData.surveyquestion) ? respoData.surveyquestion : [],
          }, () => {
            this.fetchList();
            this.fetchCountryList()
              .then(() => this.fetchChildSurveys())
              .then(() => resolve());
          });
        });
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  fetchChildSurveys(): Promise<void> {
    if (!this.props.id) return Promise.resolve();
    // Pre-screening is per-child now: each child row's own preQuestionsYN is
    // authoritative — no parent flag to compare against.
    // Fetch all children of this parent survey to populate child tabs.
    //
    // Bug A fix: when the opened survey is itself a CHILD (opened directly from
    // the survey list, not via its parent project), getChildSurveys(childId)
    // returns [] — a child has no children. The old self-seed fallback then
    // built selectedCountryOption with ONLY this one child, so same-country
    // sibling tabs ("IN 2", "IN 3") never rendered and the createdAt-based
    // suffix labelling had nothing to rank. Resolve the list off the PARENT id
    // instead so all siblings load and label identically to the parent-open
    // path. Editing still routes per-child by each row's own id (the self-seed
    // branch below remains as a defensive fallback if the parent fetch is empty).
    const selfData: any = this.state.data || {};
    const childListId = selfData && selfData.parentid ? selfData.parentid : this.props.id;
    return SurveysAPI.getChildSurveys(childListId)
      .then((children: any[]) => {
        if (!this._isMounted || !children) return;
        return new Promise<void>((resolveSetState) => {
        const childStates: Record<string, ChildSurveyState> = {};
        // Bug 1 fix: parent project's Survey Test URL / Survey Live URL are the
        // canonical fallback for any child tab that has no explicit URL of its
        // own. Empty child values should display the inherited parent values.
        // 2026-04-20 follow-up: extend the same inheritance to every other
        // country-specific field that was relocated from Project Setup into
        // the child country tab (points, quotas, send-channels, disclaimer,
        // surveyType, pointAllocationType). Backend `getChildSurveys` already
        // attempts the same backfill; this front-end pass is the second line
        // of defense for legacy child rows that pre-date the cascade.
        const parentState: any = this.state;
        const parentUrl = parentState.url || '';
        const parentTestUrl = parentState.testurl || '';
        // Helpers — only fall back when child value is genuinely empty AND
        // the field is not in overriddenFields. Never overwrite an explicit
        // per-child value (including a deliberate 0 once it's been overridden).
        const inheritStr = (childVal: any, parentVal: any, field: string, overridden: string[]): string => {
          if ((childVal === undefined || childVal === null || childVal === '') && !overridden.includes(field)) {
            return parentVal !== undefined && parentVal !== null ? String(parentVal) : '';
          }
          return childVal != null ? childVal : '';
        };
        const inheritNum = (childVal: any, parentVal: any, field: string, overridden: string[]): number => {
          const cEmpty = (childVal === undefined || childVal === null || childVal === 0 || childVal === '0' || childVal === '');
          const pHas = (parentVal !== undefined && parentVal !== null && parentVal !== 0 && parentVal !== '0' && parentVal !== '');
          if (cEmpty && !overridden.includes(field) && pHas) {
            return Number(parentVal) || 0;
          }
          return Number(childVal) || 0;
        };
        const inheritFlag = (childVal: any, parentVal: any, field: string, overridden: string[], fallback: any): any => {
          if ((childVal === undefined || childVal === null) && !overridden.includes(field) && parentVal) {
            return parentVal;
          }
          return childVal != null ? childVal : fallback;
        };
        children.forEach((child: any) => {
          const sn = child.shortName;
          if (!sn) return;
          // childStates is keyed by child.id so that same-market duplicates
          // (e.g. two AU children under one parent) each get their own entry.
          // shortName is preserved as a field for downstream logic (panel
          // detection, partner cascade scope, etc.) that needs it.
          const key = child.id;
          if (!key) return;
          const childOverridden: string[] = Array.isArray(child.overriddenFields) ? child.overriddenFields : [];
          // child.QuotaLimit may already be back-filled by the server; treat null/undefined as "needs parent"
          const parentQuota = parentState.IPollsQuotaLimit || (parentState.data && parentState.data.QuotaLimit);
          childStates[key] = {
            id: child.id,
            createdAt: child.createdAt,
            country: child.country,
            shortName: sn,
            name: child.name ? child.name.split(' [')[0] : '',
            // Free-form per-child label from the saved row (nullable → '').
            childProjectName: child.childProjectName ?? '',
            ceggPoints: inheritNum(child.ceggPoints, parentState.ceggPoints, 'ceggPoints', childOverridden),
            overquota: inheritNum(child.overquota, parentState.overquota, 'overquota', childOverridden),
            terminate: inheritNum(child.terminate, parentState.terminate, 'terminate', childOverridden),
            qualityterminate: inheritNum(child.qualityterminate, parentState.qualityterminate, 'qualityterminate', childOverridden),
            // Raw child value only — no parent fallback (matches the backend's
            // removed inheritNumberField(..., 'userLimitCommitted') calls).
            // Falsy/missing stays empty (not 0) so the required/min-1 check in
            // onSubmit() catches it instead of silently passing as 0.
            userLimitCommitted: (child.userLimitCommitted === undefined || child.userLimitCommitted === null
              || child.userLimitCommitted === 0 || child.userLimitCommitted === '0' || child.userLimitCommitted === '')
              ? undefined
              : child.userLimitCommitted,
            userLimitCutoff: inheritNum(child.userLimitCutoff, parentState.userLimitCutoff, 'userLimitCutoff', childOverridden),
            IPollsQuotaLimit: inheritFlag(child.QuotaLimit, parentQuota, 'IPollsQuotaLimit', childOverridden, 'N'),
            pointAllocationType: inheritFlag(child.pointAllocationType, parentState.pointAllocationType, 'pointAllocationType', childOverridden, 'Manual'),
            surveyType: inheritFlag(child.surveyType, parentState.surveyType, 'surveyType', childOverridden, 'Test'),
            whatsapp: inheritFlag(child.whatsapp, parentState.whatsapp, 'whatsapp', childOverridden, 'N'),
            email: inheritFlag(child.email, parentState.email, 'email', childOverridden, 'N'),
            sms: inheritFlag(child.sms, parentState.sms, 'sms', childOverridden, 'N'),
            useUniqueLinks: (child.useUniqueLinks === undefined || child.useUniqueLinks === null)
              ? (childOverridden.includes('useUniqueLinks') ? false : (parentState.useUniqueLinks ?? false))
              : child.useUniqueLinks,
            // Per-child only — no parent-level equivalent to inherit from (mirrors verisoul).
            verisoul: child.verisoul ?? false,
            verisoul_risk_threshold: child.verisoul_risk_threshold ?? 70,
            url: inheritStr(child.url, parentUrl, 'url', childOverridden),
            testurl: inheritStr(child.testurl, parentTestUrl, 'testurl', childOverridden),
            disclaimer: inheritStr(child.disclaimer, parentState.disclaimer, 'disclaimer', childOverridden),
            overriddenFields: childOverridden,
            removedPreScreenQuestionIds: [],
            // Per-child master toggle, authoritative on the child row.
            preQuestionsYN: child.preQuestionsYN === 'Y' ? 'Y' : 'N',
            selectedPreScreenQues: [],
            details: [],
            submittedAnswerDets: [],
          };
        });

        console.log('=== LOADED CHILD SURVEYS ===');
        Object.entries(childStates).forEach(([key, val]: [string, any]) => {
          console.log(`  ${key}: preQuestionsYN=${val.preQuestionsYN}, overriddenFields=${JSON.stringify(val.overriddenFields)}`);
        });

        // Build selectedCountryOption with ONE entry per child survey (not per
        // shortName) so same-market duplicates each get their own tab. Carry
        // child.id on each option so downstream tab keying, childStates lookup,
        // and childrenData[i] emission can route per-child.
        this.setState((prev: any) => {
          // Existing entries are keyed by id. New-country options (unsaved,
          // selected via the country picker) carry no id yet — we preserve
          // them as-is. Saved children that already have an entry get skipped.
          const existingChildIds = new Set(
            prev.selectedCountryOption.filter((o: any) => o.id).map((o: any) => o.id)
          );
          const newOptions = children
            .filter((c: any) => c.shortName && c.id && !existingChildIds.has(c.id))
            .map((c: any) => {
              // Find matching option from the countries list to inherit label/value
              const match = prev.countries.find((o: any) => o.shortName === c.shortName);
              const base = match || { label: c.country || c.shortName, value: c.country || c.shortName, shortName: c.shortName };
              // Override with child-specific identifiers so each duplicate is unique.
              return { ...base, id: c.id, createdAt: c.createdAt };
            });
          const mergedCountryOption = [...prev.selectedCountryOption, ...newOptions];

          // Bug 1 follow-up #3 (2026-04-20): if THIS survey is itself a child
          // (opened directly from the survey list, not via its parent project),
          // `getChildSurveys(thisChildId)` returns []. Without seeding, the
          // single country tab renders with DEFAULT_CHILD_STATE (zeros / blanks)
          // even though the merged values returned by getOne are sitting in
          // top-level state (this.state.url, this.state.disclaimer, etc.).
          // Seed childStates[shortName] from prev top-level state + prev.data
          // so the country tab reflects the inherited values.
          let seededChildStates = childStates;
          const selfData = prev.data || {};
          if ((!children || children.length === 0) && selfData && selfData.parentid) {
            const sn = selfData.shortName;
            const selfKey = selfData.id;
            if (sn && selfKey && !childStates[selfKey]) {
              const selfOverridden: string[] = Array.isArray(selfData.overriddenFields)
                ? selfData.overriddenFields : [];

              // Seed prescreening picks from the surveyquestion payload that
              // accompanied this child's getOne — same source loadChildPreScreenOverrides
              // would otherwise re-fetch. Build details[] in the canonical persistence
              // shape (full answerId arrays preserving every option's mark='y'|'n').
              const initialSurveyQuestion: any[] = Array.isArray(prev.initialSurveyQuestion)
                ? prev.initialSurveyQuestion : [];
              const selfDetails = initialSurveyQuestion
                .slice()
                .sort((a: any, b: any) => (a.questionDisplayOrder || 0) - (b.questionDisplayOrder || 0))
                .map((sq: any) => ({
                  id: sq.question_id,
                  question: sq.question,
                  questionType: sq.questionType,
                  type: sq.type,
                  answerId: Array.isArray(sq.answerId) ? sq.answerId : [],
                  questionDisplayOrder: sq.questionDisplayOrder || 0,
                }));
              const selfSubmittedAnswerDets = selfDetails
                .filter((d: any) => (d.answerId || []).some((a: any) => a && a.mark === 'y'))
                .map((d: any) => d.id);

              const selfAsChild: ChildSurveyState = {
                ...DEFAULT_CHILD_STATE,
                id: selfData.id,
                createdAt: selfData.createdAt,
                country: selfData.country || '',
                shortName: sn,
                // SMS/WhatsApp Name is stored in the child row's `name` column.
                // Seed from the actual stored value so the country tab input
                // shows what's persisted (not a derived identifier). Strip the
                // legacy " [..]" suffix the fetch-loop also strips.
                name: selfData.name
                  ? String(selfData.name).split(' [')[0]
                  : (selfData.projectname
                      ? String(selfData.projectname)
                      : (prev.projectName || '')),
                ceggPoints: Number(prev.ceggPoints ?? selfData.ceggPoints ?? 0) || 0,
                overquota: prev.overquota ?? selfData.overquota ?? 2,
                terminate: prev.terminate ?? selfData.terminate ?? 2,
                qualityterminate: Number(prev.qualityterminate ?? selfData.qualityterminate ?? 0) || 0,
                // Raw value from the loaded child row only — no prev/self
                // fallback (matches the backend's removed inheritNumberField
                // calls). Falsy/missing stays empty (not 0) so the
                // required/min-1 check in onSubmit() catches it. Cast to `any`
                // — ChildSurveyState types this field as `number`, but an
                // empty input must be able to hold `undefined` until the PM
                // fills it in.
                userLimitCommitted: ((selfData.userLimitCommitted === undefined || selfData.userLimitCommitted === null
                  || selfData.userLimitCommitted === 0 || selfData.userLimitCommitted === '0' || selfData.userLimitCommitted === '')
                  ? undefined
                  : selfData.userLimitCommitted) as any,
                userLimitCutoff: Number(prev.userLimitCutoff ?? selfData.userLimitCutoff ?? 0) || 0,
                IPollsQuotaLimit: prev.IPollsQuotaLimit
                  ?? selfData.QuotaLimit ?? selfData.IPollsQuotaLimit ?? 'N',
                pointAllocationType: prev.pointAllocationType ?? selfData.pointAllocationType ?? 'Manual',
                surveyType: prev.surveyType ?? selfData.surveyType ?? 'Test',
                whatsapp: prev.whatsapp ?? selfData.whatsapp ?? 'N',
                email: prev.email ?? selfData.email ?? 'N',
                sms: prev.sms ?? selfData.sms ?? 'N',
                useUniqueLinks: (prev.useUniqueLinks !== undefined && prev.useUniqueLinks !== null)
                  ? !!prev.useUniqueLinks
                  : !!(selfData.useUniqueLinks),
                verisoul: !!(selfData.verisoul),
                verisoul_risk_threshold: selfData.verisoul_risk_threshold ?? 70,
                url: prev.url ?? selfData.url ?? '',
                testurl: prev.testurl ?? selfData.testurl ?? '',
                disclaimer: prev.disclaimer ?? selfData.disclaimer ?? '',
                overriddenFields: selfOverridden,
                removedPreScreenQuestionIds: [],
                preQuestionsYN: selfData.preQuestionsYN === 'Y' ? 'Y' : 'N',
                // selectedPreScreenQues stays empty here; loadChildPreScreenOverrides
                // populates it with the option-shape projection once the question
                // pool has loaded. details/submittedAnswerDets carry the raw picks
                // immediately so the form has the right shape on first render and
                // a no-op save round-trips correctly.
                selectedPreScreenQues: [],
                details: selfDetails,
                submittedAnswerDets: selfSubmittedAnswerDets,
              };
              seededChildStates = { ...childStates, [selfKey]: selfAsChild };

              // Make sure the single country tab is visible even if
              // selectedCountryOption hasn't picked up the child's country.
              const alreadyHasSelfChild = existingChildIds.has(selfKey)
                || newOptions.some((o: any) => o.id === selfKey);
              if (!alreadyHasSelfChild) {
                const match = prev.countries.find((o: any) => o.shortName === sn);
                const base = match || {
                  label: selfData.country || sn,
                  value: selfData.country || sn,
                  shortName: sn,
                };
                mergedCountryOption.push({ ...base, id: selfKey, createdAt: selfData.createdAt });
              }
            }
          }

          return { childStates: seededChildStates, selectedCountryOption: mergedCountryOption };
        }, () => resolveSetState());
        });
      })
      .catch((err: any) => {
        console.error('Failed to fetch child surveys:', err);
      });
  }

  fetchCountryList(): Promise<void> {
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }); })
      .then(() => MasterDataAPI.countryList('10000'))
      .then((countries: any) => {
        if (!this._isMounted) return;
        const options = countries.map((c: any) => ({
          label: c.name, value: c.name, shortName: c.shortName,
        }));
        options.sort((a: any, b: any) => a.label.localeCompare(b.label));
        this.setState({ countries: options, status: PageStatus.Loaded });

        // Stage A: tag id-less options entering selectedCountryOption with a
        // stable nonce so react-select (via getOptionValue in ParentProjectTab)
        // identifies same-country CREATE picks per-instance instead of
        // collapsing them on `value`. Saved children carry `id` already;
        // we only stamp options that have neither.
        const stampNonce = (o: any) => (o.id || o.nonce) ? o
          : { ...o, nonce: `${o.shortName}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}` };

        const countryState = this.state.country || [];
        let changedVariable = isArray(countryState) ? countryState : [countryState];
        if (!this.props.id && changedVariable.length > 0) {
          // state.country-derived seeding is for the CREATE path only. In EDIT
          // mode (this.props.id set) — whether editing a PARENT or a CHILD
          // survey — the country list is built authoritatively by
          // fetchChildSurveys: real child rows for a parent, or the self-seed
          // branch for a leaf child. Seeding here from state.country would add
          // an id-less option that fetchChildSurveys' id-based dedup cannot
          // match — producing a phantom duplicate tab (e.g. "JP" + "JP 2").
          const option = options
            .filter((item: any) => changedVariable.some((name: any) => item.label === name))
            .map(stampNonce);
          if (option.length > 0) {
            this.setState({ selectedCountryOption: option });
            // Initialize child states for existing countries
            this.ensureChildStates(option);
          }
        } else if (!this.props.id) {
          // Default-country seeding is for the CREATE path only. In EDIT mode
          // (this.props.id set) the country list is built authoritatively by
          // fetchChildSurveys from the real child rows. Seeding a default here
          // would add an id-less option that fetchChildSurveys' id-based dedup
          // cannot match — producing a phantom duplicate tab (e.g. "JP" + "JP 2"
          // from a single JP child).
          const selectedCode = this.props.selectedCountry;
          let defaultCountry: any;
          if (selectedCode && selectedCode !== 'ALL') {
            defaultCountry = options.find((o: any) => o.shortName === selectedCode);
          }
          if (!defaultCountry) {
            defaultCountry = options.find((o: any) => o.value === 'India') || options[0];
          }
          if (defaultCountry) {
            const stamped = stampNonce(defaultCountry);
            this.setState({
              country: [{ name: stamped.label, shortName: stamped.shortName }],
              selectedCountryOption: [stamped],
            });
            this.ensureChildStates([stamped]);
          }
        }
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  fetchList(): Promise<void> {
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }); })
      .then(() => SurveysAPI.getAll(10000, 1, {}))
      .then((surveys: any) => {
        if (!this._isMounted) return;
        let responseData: any = surveys;
        // `||` not `??`: getSurveyDisplayName returns '' (not null) for a
        // nameless row, and `??` would let that empty string reach the label.
        const options = responseData.data.map((item: any) => ({
          label: getSurveyDisplayName(item) || 'N.A.',
          value: item.id,
        }));
        this.setState({ options, status: PageStatus.Loaded });
        // In edit mode, fetchCountryList is chained from fetchDetails → fetchChildSurveys.
        // Calling it here too creates a race that resets selectedCountryOption to just India.
        if (!this.props.id) {
          this.fetchCountryList();
        }
        this.preScreenFetchList();
        this.fetchClientsList();
        this.fetchPmList();
        if (this.state.data.surveyblacklistentities) {
          const selectedSurveyOptionss = this.state.data?.surveyblacklistentities
            .map((item: any) => options.filter((ele: any) => ele.value === item.blacklistSurveyId)).flat();
          const blacklistSurvey: string[] = [];
          selectedSurveyOptionss.forEach((ele: any) => blacklistSurvey.push(ele.value));
          if (selectedSurveyOptionss) {
            this.setState({ blacklistSurvey, selectedSurveyOptionss });
          }
        }
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  fetchPmList(): Promise<void> {
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }); })
      .then(() => SurveysAPI.pmListAPI())
      .then((response: any) => {
        if (!this._isMounted) return;
        let pmData = response.map((ele: any) => {
          let value = '';
          if (ele.basic_profile.firstName) {
            value += ele.basic_profile.firstName += ele.basic_profile.lastName ? ' ' : '';
          }
          if (ele.basic_profile.lastName) {
            value += ele.basic_profile.lastName;
          }
          // userId is carried through so the PM <select> can submit pmId
          // alongside pmName. pmList returns basic_profile.userId (see
          // backend surveys.controllers.js pmList).
          return { label: value, value, userId: ele.basic_profile.userId };
        });
        this.setState({ pmData, status: PageStatus.Loaded });
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  fetchClientsList(): Promise<void> {
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }); })
      .then(() => PartnersAPI.getAllClients(10000, 1))
      .then((data: any) => {
        if (!this._isMounted) return;
        const options = data.data.map((client: any) => ({
          label: client.name, value: client.id,
        }));
        options.sort((a: any, b: any) => a.label.localeCompare(b.label));
        this.setState({ clientOptions: options, status: PageStatus.Loaded });
        if (this.state.client) {
          let selectedClient = options.filter((ele: any) => ele.label === this.state.client);
          if (selectedClient.length > 0) this.setState({ client: selectedClient[0] });
        }
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  // ==================== PRE-SCREENING ====================

  isAnswerEqual(answer: any, selectedAnswer: any) {
    return JSON.stringify(answer) === JSON.stringify(selectedAnswer);
  }
  answerExistsInAnswers(answers: any[], selectedAnswer: any) {
    return answers.some((a: any) => this.isAnswerEqual(a, selectedAnswer));
  }
  isMarkedYes(elem: any) { return elem.mark === 'y'; }
  transformElem(elem: any) {
    return {
      answer: elem.answer,
      mark: elem.mark,
      questionQuotaPoints: elem.questionQuotaPoints ?? 0,
      completeCount: elem.completeCount >= 0 ? elem.completeCount : null,
    };
  }

  /**
   * Loads the question pool (preScreenOptions) once for the whole form. Every
   * country tab's PreScreeningSection picker reads from this. Hydration of
   * each child's persisted picks happens in loadChildPreScreenOverrides.
   */
  preScreenFetchList(): Promise<void> {
    return Promise.resolve()
      .then(() => AuthAPI.getAllQuestions({}))
      .then((preQues: any) => {
        if (!this._isMounted) return;
        const preScreenData = Array.isArray(preQues) ? preQues : [];
        // Sort custom (type='new') above profile (type='auto') so PMs see their
        // own questions first; preserve relative order within each group.
        const preScreenSorted = [...preScreenData].sort((a: any, b: any) => {
          if (a.type === 'new' && b.type === 'auto') return -1;
          if (a.type === 'auto' && b.type === 'new') return 1;
          return 0;
        });
        const preScreenOptions = preScreenSorted.map((item: any) => ({
          label: item.question,
          value: item.id,
          type: item.type,
          question: item.question,
          answers: item.answer,
          questionType: item.questionType,
          selectedAnsArr: [],
          questionDisplayOrder: '',
        }));
        this.setState({ preScreenOptions });
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ error: error.message });
      });
  }

  // ==================== PER-CHILD PRE-SCREENING HANDLERS ====================
  // Pre-screening is owned per-country. Every handler below mutates
  // childStates[shortName] only — there is no parent-level prescreening state.

  /**
   * SUPERSEDED for validation (QUOTA_GUARD_DIAGNOSIS.md, 2026-08-22 rescope):
   * this is no longer used by any cross-quota guard — every guard now uses
   * recomputeChildPrescreenQuotaCount() below, scoped to a single child, and
   * compares against that same child's own userLimitCommitted. This function
   * is retained only because this.state.totalQuestionQuotaCount is still
   * computed/stored on every prescreen edit (see call sites); nothing reads
   * that state field for validation any more.
   *
   * Recompute totalQuestionQuotaCount across ALL child markets so the submit-time
   * "Pre-Screen Quota can't be greater than Client Quota" guard still works.
   * Returns the max questionQuotaPoints sum across any selected answer-set.
   */
  recomputePrescreenQuotaCount = (childStates: Record<string, any>): number => {
    let total = 0;
    Object.values(childStates).forEach((child: any) => {
      if (child.preQuestionsYN !== 'Y') return;
      (child.selectedPreScreenQues || []).forEach((q: any) => {
        if (q.selectedAnsArr && q.selectedAnsArr.length > 0) {
          const sum = q.selectedAnsArr.reduce(
            (accum: number, e: any) => accum + parseInt(e.questionQuotaPoints || 0),
            0
          );
          if (sum > total) total = sum;
        }
      });
    });
    return total;
  };

  /**
   * Per-child replacement for recomputePrescreenQuotaCount() above. Returns
   * ONE child's own max questionQuotaPoints sum across its selected
   * answer-sets (0 if pre-screening is off for this child or nothing is
   * selected). Used by every cross-quota guard so each child's pre-screen
   * quota is checked against that same child's own Client Quota.
   */
  recomputeChildPrescreenQuotaCount = (child: any): number => {
    if (!child || child.preQuestionsYN !== 'Y') return 0;
    let total = 0;
    (child.selectedPreScreenQues || []).forEach((q: any) => {
      if (q.selectedAnsArr && q.selectedAnsArr.length > 0) {
        const sum = q.selectedAnsArr.reduce(
          (accum: number, e: any) => accum + parseInt(e.questionQuotaPoints || 0),
          0
        );
        if (sum > total) total = sum;
      }
    });
    return total;
  };

  /**
   * Shared message formatter for the per-child cross-quota guards
   * (QUOTA_GUARD_DIAGNOSIS.md rescope). Collects every failing child into one
   * alert instead of stopping at the first — e.g.
   * "DX Quota exceeds Client Quota for: India (10 > 5), Japan (40 > 30)".
   */
  formatQuotaFailures = (label: string, failures: Array<{ country: string; a: number; b: number }>): string =>
    `${label} exceeds Client Quota for: ` + failures.map((f) => `${f.country} (${f.a} > ${f.b})`).join(', ');

  /**
   * Master toggle on a child tab. When switching from N→Y, fetches the question
   * pool (preScreenOptions) once for the whole form (cached after first call).
   */
  handleChildTogglePrescreen = (childKey: string, e: any) => {
    const checked = !!e.target.checked;
    this.setState((prev: any) => {
      const childStates = { ...prev.childStates };
      const child = { ...(childStates[childKey] || {}) };
      child.preQuestionsYN = checked ? 'Y' : 'N';
      if (!checked) {
        // Clearing a market also clears its picks/answers — re-enabling starts fresh.
        child.selectedPreScreenQues = [];
        child.details = [];
        child.submittedAnswerDets = [];
      }
      childStates[childKey] = child;
      const totalQuestionQuotaCount = this.recomputePrescreenQuotaCount(childStates);
      return { childStates, totalQuestionQuotaCount };
    }, () => {
      // Lazy-load the pool the first time any market enables prescreening.
      if (checked && (this.state.preScreenOptions || []).length === 0) {
        this.preScreenFetchList();
      }
    });
  };

  /**
   * Question multi-select onChange for a child tab.
   * Mirrors the legacy parent-mode logic: derives details + submittedAnswerDets
   * from selectedPreScreenQues and prunes stale answer mappings.
   */
  handleChildPreScreenQuestions = (childKey: string, selectedQues: any[]) => {
    this.setState((prev: any) => {
      const childStates = { ...prev.childStates };
      const child = { ...(childStates[childKey] || {}) };
      const selectedPreScreenQues = selectedQues || [];
      // Newly added option needs a blank selectedAnsArr.
      const prevDetailsLen = (child.details || []).length;
      if (prevDetailsLen < selectedPreScreenQues.length) {
        selectedPreScreenQues[selectedPreScreenQues.length - 1].selectedAnsArr =
          selectedPreScreenQues[selectedPreScreenQues.length - 1].selectedAnsArr || [];
      }
      const submittedAnswerDets = (child.submittedAnswerDets || []).filter(
        (ele: any) => selectedPreScreenQues.some((q: any) => q.value === ele)
      );
      const details = selectedPreScreenQues.map((option: any) => ({
        id: option.value, question: option.question, questionType: option.questionType,
        type: option.type, answerId: option.selectedAnsArr || [],
      }));
      child.selectedPreScreenQues = selectedPreScreenQues;
      child.details = details;
      child.submittedAnswerDets = submittedAnswerDets;
      childStates[childKey] = child;
      const totalQuestionQuotaCount = this.recomputePrescreenQuotaCount(childStates);
      return { childStates, totalQuestionQuotaCount };
    });
  };

  /**
   * Open the shared SelectAnswer modal scoped to a child tab. The modal reads
   * activePreScreenChild + selectedPreScreenQueDet to decide what to mutate.
   */
  openChildPreScreenAnswerModal = (childKey: string, wholeElem: any, _indxx: number) => {
    this.setState({
      formType: 'UPDATE',
      activePreScreenChild: childKey,
      selectedPreScreenQueDet: wholeElem,
    });
  };

  onCloseModalFunc = () => { this.setState({ formType: 'NONE', activePreScreenChild: null }); };
  onCloseAddAnsModalFunc = () => { this.setState({ formType: 'UPDATE' }); };

  onFormUpdate = async (selectedElem: any) => {
    const allanswer = selectedElem.answers;
    const selectedanswer = selectedElem.selectedAnsArr;
    const markedAnswers = allanswer.map((ans: any) => {
      const selected = selectedElem.questionType === 'Range'
        ? selectedanswer.find((item: any) => item.answer.fromValue === ans.fromValue && item.answer.toValue === ans.toValue)
        : selectedanswer.find((item: any) => item.answer === ans);
      return {
        answer: ans,
        mark: selected ? 'y' : 'n',
        questionQuotaPoints: selected ? parseInt(selected.questionQuotaPoints) : 0,
      };
    });
    try {
      if (selectedElem.selectedAnsArr.length < 1) { alert('Please choose answer first'); return; }
      const childKey: string | null = this.state.activePreScreenChild;
      if (!childKey) { alert('No active country tab — re-open the answer modal.'); return; }
      this.setState({ status: PageStatus.Loading });
      this.setState((prev: any) => {
        const childStates = { ...prev.childStates };
        const child = { ...(childStates[childKey] || {}) };

        // Update submittedAnswerDets — push if not already present (preserves order).
        const submittedAnswerDets = (child.submittedAnswerDets || []).filter(
          (ele: any) => ele !== selectedElem.value
        );
        submittedAnswerDets.push(selectedElem.value);

        // Mutate the matching details[] entry's answerId.
        const details = (child.details || []).map((elem: any) =>
          elem.id === selectedElem.value ? { ...elem, answerId: markedAnswers } : elem
        );

        // Keep selectedPreScreenQues' selectedAnsArr in sync so the table
        // re-renders the new qualifying answers without a fresh fetch.
        const selectedPreScreenQues = (child.selectedPreScreenQues || []).map((q: any) =>
          q.value === selectedElem.value ? { ...q, selectedAnsArr: selectedElem.selectedAnsArr } : q
        );

        child.submittedAnswerDets = submittedAnswerDets;
        child.details = details;
        child.selectedPreScreenQues = selectedPreScreenQues;
        childStates[childKey] = child;

        const totalQuestionQuotaCount = this.recomputePrescreenQuotaCount(childStates);

        // Per-child rescope (QUOTA_GUARD_DIAGNOSIS.md): only this child's data
        // changed in this commit, so only this child needs checking — against
        // its OWN userLimitCommitted, not the stale top-level parent field.
        const childQuota = this.recomputeChildPrescreenQuotaCount(child);
        const childCommitted = Number(child.userLimitCommitted);
        if (childQuota > 0 && childCommitted > 0 && childQuota > childCommitted) {
          const label = child.shortName || childKey;
          alert(this.formatQuotaFailures('Pre-Screen Quota', [{ country: label, a: childQuota, b: childCommitted }]));
          return { ...prev, status: PageStatus.Loaded };
        }
        return { ...prev, childStates, totalQuestionQuotaCount, status: PageStatus.Loaded };
      }, () => this.onCloseModalFunc());
    } catch (err) {
      this.setState({ status: PageStatus.Error, error: 'Failed, Try again!' });
    }
  };

  addMoreOption = async (selectedElem: any) => {
    try {
      this.setState((prevVal: any) => {
        let newObj = selectedElem.questionType !== 'Range'
          ? { lable: 'Answer', name: selectedElem.questionType, value: '' }
          : { lable: 'Select Value', name: 'Range', fromValue: '', toValue: '' };
        return { ...prevVal, answersFields: [newObj], formType: 'NEWOPTION' };
      });
    } catch (err) {
      this.setState({ status: PageStatus.Error, error: 'Failed, Try again!' });
    }
  };

  setInputValueInArr = (lable: string, evnt: any, indx: number, field: string) => {
    if ((field === 'fromValue' || field === 'toValue') && checkNumberValidation(evnt)) return;
    this.setState((prevVal: any) => {
      let newArr = [...prevVal.answersFields].map((e: any, i: number) =>
        i === indx ? { ...e, [field]: evnt.target.value } : e
      );
      return { ...prevVal, answersFields: newArr };
    });
  };

  checkValidationNumber = (evnt: any, indxx: number, fieldName: string) => {
    const previouesAnsFields = this.state.selectedPreScreenQueDet.answers;
    const { answersFields } = this.state;
    this.setState((prevVal: any) => {
      let updatedAnswers = [...prevVal.answersFields];
      if (answersFields[indxx].fromValue !== '' && answersFields[indxx].toValue !== '' &&
        parseInt(answersFields[indxx].fromValue) >= parseInt(answersFields[indxx].toValue)) {
        alert("'From' value can't be equal or greater than 'To' value.");
        updatedAnswers[indxx][fieldName] = '';
      }
      if (answersFields[indxx][fieldName] !== '') {
        const answerVal = parseInt(answersFields[indxx][fieldName]);
        const answerFrom = parseInt(answersFields[indxx].fromValue);
        const answerTo = parseInt(answersFields[indxx].toValue);
        for (const elem of previouesAnsFields) {
          const prevFrom = parseInt(elem.fromValue);
          const prevTo = parseInt(elem.toValue);
          if (answerVal <= prevTo && answerVal >= prevFrom) {
            alert(`${updatedAnswers[indxx][fieldName]} is included in previous options.`);
            updatedAnswers[indxx][fieldName] = '';
            break;
          }
          if (answersFields[indxx].fromValue !== '' && answersFields[indxx].toValue !== '' &&
            (answerFrom < prevTo && answerFrom < prevFrom) && (answerTo > prevTo && answerTo > prevFrom)) {
            alert('Previous options are included in current range.');
            updatedAnswers[indxx][fieldName] = '';
            break;
          }
        }
      }
      return { ...prevVal, answersFields: updatedAnswers };
    });
  };

  addNewOptionToSelectedQue = () => {
    this.setState((prevData: any) => {
      const childKey: string | null = prevData.activePreScreenChild;
      if (!childKey) { alert('No active country tab — re-open the answer modal.'); return { ...prevData }; }
      if (prevData.selectedPreScreenQueDet.questionType !== 'Range') {
        if (prevData.answersFields[0].value === '') { alert('Fill option value first'); return { ...prevData }; }
      } else if (prevData.answersFields[0].fromValue === '' || prevData.answersFields[0].toValue === '') {
        alert(`${prevData.answersFields[0].fromValue === '' ? "Fill 'From' value" : "Fill 'To' value"}`);
        return { ...prevData };
      }
      const childStates = { ...prevData.childStates };
      const child = { ...(childStates[childKey] || {}) };
      const newDummyArr = (child.selectedPreScreenQues || []).map((elem: any) => {
        if (elem.value === prevData.selectedPreScreenQueDet.value) {
          const blockArr = prevData.selectedPreScreenQueDet.questionType !== 'Range'
            ? prevData.answersFields.map((ele: any) => ele.value)
            : prevData.answersFields;
          return { ...elem, answers: [...elem.answers, ...blockArr] };
        }
        return elem;
      });
      child.selectedPreScreenQues = newDummyArr;
      childStates[childKey] = child;
      return { ...prevData, childStates, formType: 'UPDATE' };
    });
  };

  handleAnswerChange = (event: any, ansVal: any, idValue: string, type: string) => {
    const childKey: string | null = this.state.activePreScreenChild;
    if (!childKey) return;
    const child = this.state.childStates[childKey] || {};
    const newArp = (child.selectedPreScreenQues || []).map((e: any) => ({ ...e }));
    newArp.forEach((ele: any) => {
      if (ele.value === idValue) {
        if (type === 'checkbox') {
          // Every non-Range type toggles membership. The admin may mark any
          // number of qualifying options regardless of how the respondent
          // answers (Radio/Dropdown stay single-select on the runtime page);
          // the evaluator ORs across every mark:'y' entry.
          ele.selectedAnsArr = event.target.checked
            ? [...(ele.selectedAnsArr || []), { answer: ansVal, mark: 'y', questionQuotaPoints: 0 }]
            : (ele.selectedAnsArr || []).filter((e: any) => e.answer !== ansVal);
        } else if (type === 'Range') {
          ele.selectedAnsArr = event.target.checked
            ? [...(ele.selectedAnsArr || []), { answer: ansVal, mark: 'y', questionQuotaPoints: 0 }]
            : (ele.selectedAnsArr || []).filter((e: any) => e.answer.fromValue !== ansVal.fromValue && e.answer.toValue !== ansVal.toValue);
        } else {
          ele.selectedAnsArr = [...(ele.selectedAnsArr || []), { answer: ansVal, mark: 'y', questionQuotaPoints: 0 }]
            .filter((e: any) => e.answer === ansVal && e.answer !== '');
        }
      }
    });
    const updatedDet = newArp.find((ele: any) => ele.value === idValue);
    this.setState((prevState: any) => {
      const childStates = { ...prevState.childStates };
      const updatedChild = { ...(childStates[childKey] || {}) };
      updatedChild.selectedPreScreenQues = newArp;
      childStates[childKey] = updatedChild;
      return {
        ...prevState,
        childStates,
        selectedPreScreenQueDet: updatedDet ? { ...updatedDet } : prevState.selectedPreScreenQueDet,
      };
    });
  };

  addQuotaPointsToAns = (val: any, _indxx: number) => {
    this.setState((prevState: any) => {
      const { selectedPreScreenQueDet } = prevState;
      let newNumber: number;
      if (selectedPreScreenQueDet.questionType !== 'Range') {
        newNumber = selectedPreScreenQueDet.selectedAnsArr.find((ele: any) => ele.answer === val)?.questionQuotaPoints;
      } else {
        newNumber = selectedPreScreenQueDet.selectedAnsArr.find((ele: any) => ele.answer.fromValue === val.fromValue && ele.answer.toValue === val.toValue)?.questionQuotaPoints;
      }
      return { formType: 'ADDQUOTAPOINTS', quotaPointAnswer: val, questionQuotaPoints: newNumber || 0 };
    });
  };

  addQuotaPointsToPreScreenQue = () => {
    if (this.state.questionQuotaPoints !== '') {
      this.setState((prevVal: any) => {
        let newObj = prevVal.selectedPreScreenQueDet;
        let deepCopy = structuredClone(prevVal.selectedPreScreenQueDet);
        deepCopy.selectedAnsArr.forEach((ele: any) => {
          if (deepCopy.questionType !== 'Range') {
            if (ele.answer === prevVal.quotaPointAnswer) ele.questionQuotaPoints = prevVal.questionQuotaPoints;
          } else if (parseInt(ele.answer.fromValue) === prevVal.quotaPointAnswer.fromValue && parseInt(ele.answer.toValue) === prevVal.quotaPointAnswer.toValue) {
            ele.questionQuotaPoints = prevVal.questionQuotaPoints;
          }
        });
        if (deepCopy.selectedAnsArr.length > 0) {
          let countSelectedQueQuota = deepCopy.selectedAnsArr.reduce((accum: number, ele: any) => accum + parseInt(ele.questionQuotaPoints), 0);
          // Per-child rescope (QUOTA_GUARD_DIAGNOSIS.md): compare against the
          // active child's OWN userLimitCommitted, not the stale top-level
          // parent field. activePreScreenChild identifies which child tab
          // opened this modal (openChildPreScreenAnswerModal).
          const activeChildKey: string | null = prevVal.activePreScreenChild;
          const activeChild = activeChildKey ? (prevVal.childStates || {})[activeChildKey] : undefined;
          const activeChildCommitted = Number(activeChild && activeChild.userLimitCommitted);
          if (countSelectedQueQuota > 0 && activeChildCommitted > 0 && countSelectedQueQuota > activeChildCommitted) {
            const label = (activeChild && activeChild.shortName) || activeChildKey;
            alert(this.formatQuotaFailures('Pre-Screen Quota', [{ country: label, a: countSelectedQueQuota, b: activeChildCommitted }]));
            return { ...prevVal, quotaPointAnswer: '', questionQuotaPoints: 0, formType: 'UPDATE' };
          }
        }
        newObj.selectedAnsArr.forEach((ele: any) => {
          if (newObj.questionType !== 'Range') {
            if (ele.answer === prevVal.quotaPointAnswer) ele.questionQuotaPoints = parseInt(prevVal.questionQuotaPoints);
          } else if (parseInt(ele.answer.fromValue) === prevVal.quotaPointAnswer.fromValue && parseInt(ele.answer.toValue) === prevVal.quotaPointAnswer.toValue) {
            ele.questionQuotaPoints = parseInt(prevVal.questionQuotaPoints);
          }
        });
        return { ...prevVal, selectedPreScreenQueDet: newObj, quotaPointAnswer: '', questionQuotaPoints: 0, formType: 'UPDATE' };
      });
    } else { alert('Please enter valid value'); }
  };

  setQuotaPointsToPreScreenQue = (event: any) => {
    if (!checkNumberValidation(event) && event.target.value >= 0) {
      this.setState({ questionQuotaPoints: event.target.value });
    }
  };

  // ==================== CHILD STATE MANAGEMENT ====================

  /**
   * Single source of truth for the `childStates` key of a country option.
   * - Saved children: their backend UUID (stringified for consistent map keys).
   * - Unsaved CREATE picks: `new:<shortName>:<nonce>` so same-country duplicates
   *   each get a unique slot. The nonce is attached at pick time (see
   *   fetchCountryList + handleCountryChange). The legacy `new:<shortName>`
   *   fallback (no nonce) is retained for any code path that constructs an
   *   option without going through those entry points.
   *
   * All four call-sites that key into childStates route through this helper:
   * ensureChildStates (create/clean), formValues childrenData (submit payload),
   * submit validateKeys (prescreen validation), and render's childKeyFor
   * (tab strip + tab content). Keep them in sync via this helper only.
   */
  private childStateKey = (opt: any): string => {
    if (opt.id) return String(opt.id);
    if (!opt.nonce) {
      // Defensive: every id-less option SHOULD have a nonce attached at pick time
      // (fetchCountryList stampNonce + handleCountryChange both stamp). If this
      // fires, a new writer was added that bypasses those entry points — two
      // same-shortName unsaved picks would collapse to the same `new:<sn>` key
      // and overwrite each other's childStates. Surface so the regression is
      // visible instead of silent.
      // eslint-disable-next-line no-console
      console.warn('[childStateKey] unsaved option missing nonce; collisions possible', opt);
    }
    return 'new:' + opt.shortName + (opt.nonce ? ':' + opt.nonce : '');
  };

  /**
   * Ensure child states exist for all selected countries.
   * New countries get defaults inherited from parent.
   */
  ensureChildStates(selectedOptions: any[]) {
    this.setState((prev: any) => {
      const childStates = { ...prev.childStates };
      const keyFor = (opt: any) => this.childStateKey(opt);
      selectedOptions.forEach((opt: any) => {
        const sn = opt.shortName;
        const key = keyFor(opt);
        if (!childStates[key]) {
          const isPanel = isPanelCountry(sn);
          childStates[key] = {
            ...DEFAULT_CHILD_STATE,
            country: opt.label,
            shortName: sn,
            name: prev.name,

            // CATEGORY 1 — Parent project fields (ALL children inherit)
            userLimitCommitted: prev.userLimitCommitted,
            surveyType: prev.surveyType,

            // CATEGORY 2 — Panel-only fields (non-panel gets zeros/defaults)
            ceggPoints: 0,
            overquota: 2,
            terminate: 2,
            qualityterminate: 0,
            pointAllocationType: isPanel ? (prev.pointAllocationType || 'Manual') : 'Manual',
            userLimitCutoff: 0,
            IPollsQuotaLimit: isPanel ? (prev.IPollsQuotaLimit || 'N') : 'N',
            whatsapp: isPanel ? (prev.whatsapp || 'N') : 'N',
            email: isPanel ? (prev.email || 'N') : 'N',
            sms: isPanel ? (prev.sms || 'N') : 'N',
            // SCRUM-116: an IndiaPolls market gets its own points disclaimer,
            // flagged as its own so a project-level disclaimer change never
            // overwrites it. Other markets copy the project's, as before.
            disclaimer: isPanel ? (sn === 'IN' ? IN_DEFAULT_DISCLAIMER : (prev.disclaimer || '')) : '',
            overriddenFields: sn === 'IN' ? ['disclaimer'] : [],

            // CATEGORY 3 — All-children fields
            useUniqueLinks: prev.useUniqueLinks,
            url: '',
            testurl: '',
          };
        }
      });
      // Remove child states for deselected NEW (unsaved) entries. Saved
      // children (key === their real UUID) stay regardless of country picker
      // state — country deselection on an existing parent is handled separately.
      const selectedKeys = new Set(selectedOptions.map(keyFor));
      Object.keys(childStates).forEach((k) => {
        if (!selectedKeys.has(k) && !childStates[k].id) {
          // Only remove if it's a new (unsaved) child
          delete childStates[k];
        }
      });
      return { childStates };
    });
  }

  handleCountryChange = (selected4CountryOption: any) => {
    // Stage A: attach a stable nonce to any newly-picked (id-less, nonce-less)
    // option so react-select's per-instance identity (getOptionValue in
    // ParentProjectTab) stays distinct for same-country picks. Saved children
    // carry `id`; we only touch options that lack both `id` and `nonce`.
    //
    // The legacy EDIT-branch that re-injected `previousCountry` (the parent
    // row's single legacy `data.country` field) is retired: under the per-child
    // split, fetchChildSurveys authoritatively builds the per-instance option
    // list with ids, and re-injecting an id-less copy here would regress the
    // phantom JP / JP 2 guard (Invariant #10). `previousCountry` state remains
    // (its writer at fetchDetails ~ln 1311 is untouched) but is no longer read.
    const selectedCountryOption = (selected4CountryOption || []).map((o: any) =>
      (o.id || o.nonce) ? o : { ...o, nonce: `${o.shortName}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}` }
    );
    let countryName = selectedCountryOption.map((ele: any) => ({ name: ele.label, shortName: ele.shortName }));
    this.setState({ country: countryName, selectedCountryOption });
    this.ensureChildStates(selectedCountryOption);
  };

  /**
   * Update a single field on a child survey.
   * Tracks the field in overriddenFields if it differs from parent value.
   * childKey is the childStates map key (child.id for saved children,
   * `new:<shortName>` for unsaved ones).
   */
  updateChildField = (childKey: string, field: string, value: any) => {
    this.setState((prev: any) => {
      const childStates = { ...prev.childStates };
      const child = { ...childStates[childKey] };

      child[field] = value;

      // Track override: if value differs from parent's value, mark as overridden
      if (CHILD_OVERRIDABLE_FIELDS.includes(field)) {
        const overridden = new Set(child.overriddenFields || []);
        const parentValue = prev[field];
        // Bug 1 fix: for url/testurl/disclaimer, an empty value means
        // "inherit from parent", so it must never be marked as an override —
        // otherwise the child would lock in a blank value and never pick up
        // the parent's value.
        const inheritOnEmptyFields = ['url', 'testurl', 'disclaimer'];
        const isInheritOnEmpty = inheritOnEmptyFields.includes(field);
        const isEmpty = value === '' || value === null || value === undefined;
        if (isInheritOnEmpty && isEmpty) {
          overridden.delete(field);
        } else if (value !== parentValue) {
          overridden.add(field);
        } else {
          overridden.delete(field);
        }
        child.overriddenFields = Array.from(overridden);
      }

      childStates[childKey] = child;
      return { childStates };
    });
  };

  // toggleChildPreScreenQuestion removed: the legacy "remove inherited question
  // from this child" UX is gone; each market now picks its own questions
  // through PreScreeningSection's multi-select.

  // ==================== FORM VALUES & SUBMIT ====================

  initializeValues(paramData: any) {
    let data = paramData.data;
    const formattedExpiryDate = moment(data.expiryDate).format('YYYY-MM-DD');
    this.setState({ Newdateexpireset: formattedExpiryDate });
    return this.setState({
      name: data.name.split(' [')[0],
      company: data.company,
      description: data.description,
      userLimitCommitted: data.userLimitCommitted,
      userLimitCutoff: data.userLimitCutoff,
      client: data.client,
      ceggPoints: data.ceggPoints,
      overquota: data.overquota ?? 2,
      terminate: data.terminate ?? 2,
      qualityterminate: data.qualityterminate,
      surveyLength: data.surveyLength,
      publishDate: moment(data.publishDate).format('YYYY-MM-DD'),
      expiryDate: moment(data.expiryDate).format('YYYY-MM-DD'),
      outlierCutoffTime: data.outlierCutoffTime,
      costPerInterview: data.costPerInterview,
      isActive: data.isActive,
      companyLogo: data.companyLogo,
      useUniqueLinks: data.useUniqueLinks,
      ipUnique: data.ipUnique,
      surveyUrlIdentifier: data.surveyUrlIdentifier,
      url: data.url,
      surveyType: data.surveyType,
      pointAllocationType: data.pointAllocationType,
      minimumInterviewDuration: data.minimumInterviewDuration,
      isPaused: data.isPaused,
      disclaimer: data.disclaimer,
      description_one: data.description_one,
      description_two: data.description_two,
      description_three: data.description_three,
      description_four: data.description_four,
      country: data.country ? (Array.isArray(data.country) ? data.country : [data.country]) : [],
      colorCode: data.colorcode,
      whatsapp: data.whatsapp,
      email: data.email,
      sms: data.sms,
      clientir: data.clientir,
      IPollsQuotaLimit: data.QuotaLimit ?? data.IPollsQuotaLimit ?? 'N',
      // Top-level preQuestionsYN/details intentionally omitted: pre-screening
      // is now per-country (see loadChildPreScreenOverrides).
      validateStartEndIp: data.validateStartEndIp ?? 'N',
      validateCountry: data.validateCountry ?? 'N',
      deviceCompatibility: data.deviceCompatibility ?? 'mobile,desktop,tablet',
      pmName: data.pmName ?? '',
      // Hydrate the existing pmId so re-saving a survey without touching the
      // PM dropdown preserves it instead of nulling it out.
      pmId: data.pmId ?? '',
      projectId: data.projectId,
      projectName: data.projectname,
      parentProjectName: data.parentid ? (data.parentProjectName || '') : '',
      testurl: data.testurl,
      groupClone: paramData.groupClone,
      currency: data.currency ?? '',
      previousCountry: data.country ?? '',
    });
  }

  /**
   * The set of country/child options this modal session actually ACTS ON.
   *
   * The modal always LOADS the full sibling set (fetchChildSurveys → all
   * children) so the per-child suffix-label rank can be computed (Option b:
   * the opened "US 2" still ranks correctly against its "US" sibling). But in
   * CHILD-OPEN mode the modal manages ONLY the opened child — so every consumer
   * that reads the family set and assumes parent-open (the Countries multiselect,
   * the submit validation loop, the submit payload) must be scoped to the opened
   * child, or it leaks siblings (shows Japan+USA; validates JP on a US child).
   *
   * Single source of truth so no consumer can leak: route them all through here.
   *   - Child-open (data.parentid set): return ONLY the opened child's option
   *     (matched by id === this.props.id; defensive fallback to full set if the
   *     opened child isn't found, to avoid an empty payload/blank field).
   *   - Parent-open / create: return the full selectedCountryOption (UNCHANGED).
   *
   * The display tab list (allCountryTabs → countryTabs) and the label-rank
   * computation are intentionally NOT routed through this — they need the full
   * set for ranking and already filter for display in render() (Option b).
   */
  getEffectiveCountryOptions(): any[] {
    const all = this.state.selectedCountryOption || [];
    const openedChildId = this.props.id;
    const isChildOpen = !!((this.state.data as any) && (this.state.data as any).parentid);
    if (isChildOpen && openedChildId) {
      const scoped = all.filter((o: any) => o.id === openedChildId);
      if (scoped.length > 0) return scoped;
    }
    return all;
  }

  /**
   * Build the new payload shape: parent data + per-child data.
   */
  formValues() {
    const parentData = {
      // Parent fields
      projectName: this.state.projectName,
      projectId: this.state.projectId,
      company: 'Dataxing',
      description: this.state.description,
      pmName: this.state.pmName,
      pmId: this.state.pmId || null,
      client: this.state.client,
      clientir: this.state.clientir,
      costPerInterview: this.state.costPerInterview,
      currency: this.state.currency,
      publishDate: this.state.publishDate,
      expiryDate: this.state.expiryDate,
      surveyLength: this.state.surveyLength,
      outlierCutoffTime: this.state.outlierCutoffTime,
      validateStartEndIp: this.state.validateStartEndIp,
      validateCountry: this.state.validateCountry,
      deviceCompatibility: this.state.deviceCompatibility,
      surveyUrlIdentifier: this.state.surveyUrlIdentifier,
      colorcode: this.state.colorCode,
      description_one: this.state.description_one,
      description_two: this.state.description_two,
      description_three: this.state.description_three,
      description_four: this.state.description_four,
      companyLogo: this.state.companyLogo,
      ipUnique: this.state.ipUnique,
      isActive: this.state.isActive,
      isPaused: false,
      minimumInterviewDuration: 20,
      blacklistSurvey: this.state.blacklistSurvey,
      // Pre-screening is per-country now. Parent record is forced to 'N' on the
      // backend; we send 'N' here as a hard signal so any older backend code
      // path that reads top-level preQuestionsYN doesn't accidentally write
      // parent metadata. Top-level `details` is intentionally absent.
      preQuestionsYN: 'N',
      // Parent name = project name (no country suffix, no points suffix)
      name: this.state.projectName || this.state.name,
      ceggPoints: this.state.ceggPoints,
      overquota: this.state.overquota,
      terminate: this.state.terminate,
      qualityterminate: this.state.qualityterminate,
      userLimitCommitted: this.state.userLimitCommitted,
      userLimitCutoff: this.state.userLimitCutoff,
      IPollsQuotaLimit: this.state.IPollsQuotaLimit,
      pointAllocationType: this.state.pointAllocationType,
      surveyType: this.state.surveyType,
      whatsapp: this.state.whatsapp,
      email: this.state.email,
      sms: this.state.sms,
      useUniqueLinks: this.state.useUniqueLinks,
      url: this.state.url,
      testurl: this.state.testurl,
      disclaimer: replacePlaceholderWithAnchor(this.state.disclaimer),
    };

    // Build per-child data array — one entry per child (saved or pending),
    // not deduped by shortName. Same-market duplicates each emit their own
    // childrenData entry so the backend can route updates per-id.
    //
    // Child-open: scope to the opened child only (getEffectiveCountryOptions) so
    // the payload carries no siblings. The backend child-direct branch already
    // writes only req.params.id (ignored the others anyway), so this preserves
    // Invariant 4 and strengthens it. Parent-open: full set (unchanged).
    const effectiveOptions = this.getEffectiveCountryOptions();
    const childrenData = effectiveOptions.map((opt: any) => {
      const sn = opt.shortName;
      const childKey = this.childStateKey(opt);
      const child = this.state.childStates[childKey] || {};
      const isPanel = isPanelCountry(sn);
      return {
        id: child.id, // existing child ID for updates (undefined for new countries)
        country: { name: opt.label, shortName: sn },
        overriddenFields: child.overriddenFields || [],
        removedPreScreenQuestionIds: child.removedPreScreenQuestionIds || [],
        // SMS/WhatsApp Name: user-editable per-child. Fall back to derived
        // `${projectName}_${sn}` only when the user hasn't typed one.
        name: (child.name && String(child.name).trim()) ? child.name : `${this.state.projectName}_${sn}`,
        // Free-form per-child label (own DB column). Always sent (incl. '') so the
        // backend can persist a clear; independent of name/projectname.
        // Normalized here — the ONLY place whitespace is cleaned up. The input
        // itself must keep the PM's raw spaces (see childProjectName.ts), so the
        // edge trim happens once, on the way out.
        childProjectName: normalizeChildProjectName(
          child.childProjectName ?? '',
          this.state.parentProjectName || this.state.projectName || '',
          sn,
        ),

        // CATEGORY 1 — Parent project fields (ALL children)
        // userLimitCommitted is now per-child only — no parent fallback. The
        // parent's own value is a derived sum (recomputeParentClientQuota on
        // the backend), never a source to inherit from.
        userLimitCommitted: child.userLimitCommitted,
        surveyType: child.surveyType ?? parentData.surveyType,

        // CATEGORY 2 — Panel-only fields
        ceggPoints: isPanel ? (child.ceggPoints ?? 0) : 0,
        overquota: isPanel ? (child.overquota ?? 0) : 0,
        terminate: isPanel ? (child.terminate ?? 0) : 0,
        qualityterminate: isPanel ? (child.qualityterminate ?? 0) : 0,
        pointAllocationType: isPanel ? (child.pointAllocationType || parentData.pointAllocationType || 'Manual') : 'Manual',
        userLimitCutoff: isPanel ? (child.userLimitCutoff ?? 0) : 0,
        IPollsQuotaLimit: isPanel ? (child.IPollsQuotaLimit || parentData.IPollsQuotaLimit || 'N') : 'N',
        whatsapp: isPanel ? (child.whatsapp || parentData.whatsapp || 'N') : 'N',
        email: isPanel ? (child.email || parentData.email || 'N') : 'N',
        sms: isPanel ? (child.sms || parentData.sms || 'N') : 'N',
        disclaimer: isPanel ? (child.disclaimer || parentData.disclaimer || '') : '',

        // CATEGORY 3 — All-children fields
        // Bug 1 fix: children inherit parent project's Survey Test URL and
        // Survey Live URL unless the PM explicitly overrode the field. An
        // empty child value is treated as "inherit" rather than "blank".
        url: ((child.overriddenFields || []).includes('url') && child.url)
          ? child.url
          : (child.url || parentData.url || ''),
        testurl: ((child.overriddenFields || []).includes('testurl') && child.testurl)
          ? child.testurl
          : (child.testurl || parentData.testurl || ''),
        useUniqueLinks: child.useUniqueLinks ?? parentData.useUniqueLinks ?? false,
        // Per-child only — no parent-level equivalent to inherit from (mirrors verisoul).
        verisoul: child.verisoul ?? false,
        verisoul_risk_threshold: child.verisoul_risk_threshold ?? 70,
        // Per-country only — backend's persistUniqueLinks reads co.uniqueLinks
        // directly and does NOT consult overriddenFields. Never inherit from parent.
        uniqueLinks: Array.isArray(child.uniqueLinks) ? child.uniqueLinks : [],
        testUniqueLinks: Array.isArray(child.testUniqueLinks) ? child.testUniqueLinks : [],

        // Per-child pre-screening — authoritative master toggle for this market.
        preQuestionsYN: child.preQuestionsYN === 'Y' ? 'Y' : 'N',
        // Per-child picked questions in the canonical persistence shape.
        // Empty array = no questions for this market (or master toggle off).
        details: child.preQuestionsYN === 'Y' ? (child.details || []).map((d: any, indxx: number) => ({
          ...d,
          questionDisplayOrder: indxx,
        })) : [],
      };
    });

    // Parent is project-level: no URL, no country suffix
    // Ensure name is never empty
    if (!parentData.name) {
      parentData.name = this.state.projectName;
    }

    return {
      ...parentData,
      // Keep legacy country array for backward compat — scoped to the opened
      // child in child-open mode (effectiveOptions), full set on parent-open.
      country: effectiveOptions.map((o: any) => ({ name: o.label, shortName: o.shortName })),
      // New per-child data
      childrenData,
    };
  }

  onSubmit() {
    if (!this.state.client) { alert('Please select a client'); return; }

    // Per-child rescope (QUOTA_GUARD_DIAGNOSIS.md): both cross-quota guards
    // below used to compare this.state.userLimitCutoff/.userLimitCommitted/
    // .IPollsQuotaLimit — the PARENT row's own frozen columns, loaded once at
    // page-open and never updated during the edit session — instead of what
    // the PM actually edits (childStates[key]). Iterate the currently
    // selected/effective children (getEffectiveCountryOptions excludes
    // deselected/removed countries; same scoping already used by the
    // pre-screening and Client-Quota-required loops below) and check each
    // child against its OWN Client Quota, collecting every failure instead
    // of stopping at the first.
    const childStates: Record<string, any> = this.state.childStates || {};
    const validateKeys = this.getEffectiveCountryOptions().map((o: any) => this.childStateKey(o));
    const dxQuotaFailures: Array<{ country: string; a: number; b: number }> = [];
    const preScreenQuotaFailures: Array<{ country: string; a: number; b: number }> = [];
    for (const childKey of validateKeys) {
      const child = childStates[childKey] || {};
      const label = child.shortName || childKey;
      const committed = Number(child.userLimitCommitted);

      if (child.IPollsQuotaLimit === 'Y' && Number(child.userLimitCutoff) > 0 && committed > 0
          && Number(child.userLimitCutoff) > committed) {
        dxQuotaFailures.push({ country: label, a: Number(child.userLimitCutoff), b: committed });
      }

      const childPrescreenQuota = this.recomputeChildPrescreenQuotaCount(child);
      if (childPrescreenQuota > 0 && committed > 0 && childPrescreenQuota > committed) {
        preScreenQuotaFailures.push({ country: label, a: childPrescreenQuota, b: committed });
      }
    }
    if (dxQuotaFailures.length > 0) {
      alert(this.formatQuotaFailures('DX Quota', dxQuotaFailures)); return;
    }
    if (preScreenQuotaFailures.length > 0) {
      alert(this.formatQuotaFailures('Pre-Screen Quota', preScreenQuotaFailures)); return;
    }
    // Per-country pre-screening validation: walk every child that has the
    // master toggle on. Empty pick or unmapped answer is a hard error.
    //
    // Child-open: validate ONLY the opened child — never siblings. Previously
    // this looped the full childStates (all siblings loaded for label-rank), so
    // a US-child submit raised "JP: pre-screening enabled but no questions" for
    // an unrelated JP sibling. Scope the validated keys to getEffectiveCountryOptions
    // (the opened child in child-open; all children on parent-open — unchanged).
    for (const childKey of validateKeys) {
      const child = childStates[childKey] || {};
      if (child.preQuestionsYN !== 'Y') continue;
      const label = child.shortName || childKey;
      const details = child.details || [];
      if (details.length < 1) {
        alert(`${label}: Pre-screening is enabled but no questions are selected.`); return;
      }
      const missing = details.find((d: any) => !d.answerId || d.answerId.length < 1);
      if (missing) {
        alert(`${label}: Answer is not selected for the question\n\n${missing.question}`); return;
      }
    }
    // Client Quota is now required per child (minimum 1) — no parent
    // fallback. Same validateKeys scoping as the pre-screening loop above.
    for (const childKey of validateKeys) {
      const child = childStates[childKey] || {};
      const quota = Number(child.userLimitCommitted);
      if (child.userLimitCommitted === undefined || child.userLimitCommitted === null || child.userLimitCommitted === ''
          || !Number.isFinite(quota) || quota < 1) {
        const label = child.shortName || childKey;
        alert(`${label}: Client Quota is required (minimum 1).`); return;
      }
    }
    if (this.state.expiryDate && this.state.publishDate && new Date(this.state.expiryDate) < new Date(this.state.publishDate)) {
      alert('End date must be after start date'); return;
    }
    if (this.state.selectedCountryOption.length === 0) {
      alert('Please select at least one country.'); return;
    }
    if (!this.state.projectName) {
      alert('Please enter a Project Name.'); return;
    }
    if (!this.state.projectId) {
      alert('Please enter a Project ID.'); return;
    }
    // company is hardcoded to 'Dataxing' — no validation needed
    if (!this.props.id && !this.state.createdSurveyId) {
      return this.create();
    }
    return this.update();
  }

  create() {
    const valuesIn = this.formValues();
    console.log('=== SURVEY CREATE PAYLOAD ===');
    console.log('Parent preQuestionsYN:', valuesIn.preQuestionsYN);
    console.log('childrenData:', JSON.stringify(valuesIn.childrenData?.map((c: any) => ({
      country: c.country?.shortName,
      ceggPoints: c.ceggPoints,
      terminate: c.terminate,
      overquota: c.overquota,
      qualityterminate: c.qualityterminate,
      userLimitCommitted: c.userLimitCommitted,
      userLimitCutoff: c.userLimitCutoff,
      IPollsQuotaLimit: c.IPollsQuotaLimit,
      email: c.email,
      whatsapp: c.whatsapp,
      sms: c.sms,
      preQuestionsYN: c.preQuestionsYN,
      overriddenFields: c.overriddenFields,
    })), null, 2));
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Submitting }); })
      .then(() => SurveysAPI.create(valuesIn))
      .then((data: any) => {
        if (!this._isMounted) return;
        const surveyName = this.state.projectName || data.Survey?.name || 'Survey';
        Swal.fire({
          title: 'Created!',
          text: `${surveyName} has been created successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
          didOpen: () => {
            const container = Swal.getContainer();
            if (container) container.style.zIndex = '9999';
          },
        });
        // Refresh background list but keep modal open
        if (this.props.onRefresh) this.props.onRefresh();
        // Capture per-child unique-link upload outcomes (Ask 4) so ChildSurveyTab
        // can render the "X added, Y duplicates skipped" feedback inline. Backend
        // omits the key when no child uploaded a non-empty CSV.
        const uniqueLinksUploadResults = (data && data.uniqueLinksUploadResults) || {};
        // Store the new ID so subsequent submits call update() instead of creating again
        return this.setState({
          status: PageStatus.Submitted,
          submittedAnswerDets: [],
          createdSurveyId: data.Survey.id,
          lastUniqueLinksUploadResults: uniqueLinksUploadResults,
        });
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  update() {
    const id = this.props.id || this.state.createdSurveyId;
    // Captured synchronously, in the same tick as formValues() below (which
    // computes an identical array internally via the same
    // getEffectiveCountryOptions() call). This is the exact tab order/identity
    // the backend's `children` response will be index-aligned to (see
    // formValues()'s childrenData/country construction). Capturing it here,
    // before the network round-trip, means the rehydration match in the
    // success handler is immune to any selectedCountryOption change that
    // happens while the request is in flight (e.g. the user adding/removing
    // a country tab mid-save).
    const effectiveOptionsAtSubmit = this.getEffectiveCountryOptions();
    const valuesIn = this.formValues();
    console.log('=== SURVEY UPDATE PAYLOAD ===');
    console.log('Parent preQuestionsYN:', valuesIn.preQuestionsYN);
    console.log('childrenData:', JSON.stringify(valuesIn.childrenData?.map((c: any) => ({
      country: c.country?.shortName,
      ceggPoints: c.ceggPoints,
      terminate: c.terminate,
      overquota: c.overquota,
      qualityterminate: c.qualityterminate,
      userLimitCommitted: c.userLimitCommitted,
      userLimitCutoff: c.userLimitCutoff,
      IPollsQuotaLimit: c.IPollsQuotaLimit,
      email: c.email,
      whatsapp: c.whatsapp,
      sms: c.sms,
      preQuestionsYN: c.preQuestionsYN,
      overriddenFields: c.overriddenFields,
    })), null, 2));
    // Diagnostic: log the actual url/testurl values being sent and the
    // form state at submit time. Inert unless localStorage.diagnoseUrlUpdate==='1'.
    logSubmitState('Form.update', { ...this.state, _payloadUrl: valuesIn.url, _payloadTestUrl: valuesIn.testurl });
    return Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Submitting }); })
      .then(() => SurveysAPI.update(id, valuesIn))
      .then((data: any) => {
        if (!this._isMounted) return;
        const surveyName = this.state.projectName || 'Survey';
        Swal.fire({
          title: 'Updated!',
          text: `${surveyName} has been updated successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
          didOpen: () => {
            const container = Swal.getContainer();
            if (container) container.style.zIndex = '9999';
          },
        });
        // Refresh background list but keep modal open
        if (this.props.onRefresh) this.props.onRefresh();
        // Capture per-child unique-link upload outcomes (Ask 4) for ChildSurveyTab
        // inline feedback. Backend omits the key when no child uploaded a CSV.
        const uniqueLinksUploadResults = (data && data.uniqueLinksUploadResults) || {};

        // Rehydrate real child ids so the NEXT save identifies these tabs by
        // id instead of resending them 'new:'-keyed — that gap is what let
        // DXD-6655 duplicate a child on every repeated save. Deliberately NOT
        // calling fetchChildSurveys() here: it rebuilds the whole childStates
        // map from a fresh fetch and would clobber any edit made in another
        // tab while this request was in flight — the exact failure mode
        // loadChildPreScreenOverrides's own comment above documents as Bug B.
        // Instead: relocate just the affected entries, reading only `prev`
        // inside one functional setState.
        //
        // Matching: the backend's `children` array is index-aligned with
        // req.body.country (verified server-side). effectiveOptionsAtSubmit
        // was captured synchronously alongside the formValues() call that
        // produced req.body.country, so index i here is guaranteed to be the
        // same tab as children[i] no matter what changed in state since.
        const returnedChildren: any[] = (data && Array.isArray(data.children)) ? data.children : [];
        const rehydrations = effectiveOptionsAtSubmit
          .map((opt: any, i: number) => ({ opt, returned: returnedChildren[i] }))
          .filter(({ opt, returned }: any) => !opt.id && returned && returned.id)
          .map(({ opt, returned }: any) => ({
            oldKey: this.childStateKey(opt),
            newId: String(returned.id),
            nonce: opt.nonce,
          }));

        return this.setState((prev: any) => {
          // Read ONLY prev — never a closed-over snapshot — so any edit the
          // user made in ANY tab while this request was in flight survives.
          // We only relocate the entry and stamp its id; every other field
          // passes through untouched via the spread (STEP 3: no field reset).
          const childStates = { ...prev.childStates };
          rehydrations.forEach(({ oldKey, newId }: any) => {
            const existingTab = childStates[oldKey];
            // Tab may have been removed from the picker mid-flight, or a
            // real-id entry may already occupy newId (shouldn't happen, but
            // never clobber it if it does) — leave state alone either way.
            if (!existingTab || childStates[newId]) return;
            childStates[newId] = { ...existingTab, id: newId };
            delete childStates[oldKey];
          });

          // childStateKey reads opt.id off selectedCountryOption entries, so
          // it must carry the same real id or the tab looks up an empty key
          // on the next render/submit — update both maps in this one setState.
          const selectedCountryOption = (prev.selectedCountryOption || []).map((o: any) => {
            if (o.id) return o;
            const match = rehydrations.find((r: any) => r.nonce && o.nonce === r.nonce);
            return match ? { ...o, id: match.newId } : o;
          });

          return {
            status: PageStatus.Submitted,
            submittedAnswerDets: [],
            lastUniqueLinksUploadResults: uniqueLinksUploadResults,
            childStates,
            selectedCountryOption,
          };
        });
      })
      .catch((error: any) => {
        if (this._isMounted) this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  reset() {
    return this.setState({
      data: '', name: '', company: '', description: '',
      userLimitCommitted: 0, userLimitCutoff: 0, client: '',
      ceggPoints: 0, terminate: 2, overquota: 2, surveyLength: 0, publishDate: '', expiryDate: '',
      outlierCutoffTime: 0, costPerInterview: 0, isActive: true,
      companyLogo: '', useUniqueLinks: false, ipUnique: false,
      surveyUrlIdentifier: 'id', url: '', surveyType: 'Test',
      pointAllocationType: 'Manual', isPaused: false,
      selectedCountryOption: [], country: [],
      description_one: '', description_two: '', description_three: '', description_four: '',
      colorCode: '', whatsapp: 'N', email: 'N', sms: 'N', clientir: '',
      answersFields: [], pmName: '', pmId: '', validateStartEndIp: 'Y', validateCountry: 'Y',
      projectId: '', projectName: '', parentProjectName: '', testurl: '',
      totalQuestionQuotaCount: 0,
      activePreScreenChild: null, selectedPreScreenQueDet: {}, formType: 'NONE',
      currency: '', childStates: {}, activeTab: 'parent',
      blacklistSurvey: [], selectedSurveyOptionss: [],
      deviceCompatibility: 'mobile,desktop,tablet',
    });
  }

  // ==================== PARENT STATE SETTER ====================

  setParentState = (updates: any, cb?: () => void) => {
    // Cross-update child prefixes when the parent projectName changes in CREATE mode.
    // Each childStates[key].childProjectName is the FULL combined string
    // `${projectName}_${shortName}` (no suffix) or `${projectName}_${shortName}_${suffix}`.
    // When the PM renames the parent in create mode we rewrite each row that still
    // matches the OLD prefix to the NEW prefix, preserving its suffix portion.
    // Rows whose stored value is empty or doesn't match the old prefix are left alone
    // (the input-group's legacy/mismatched branch will display them so PM can normalize).
    // In EDIT mode we never touch stored child names — same gate `!this.props.id` used
    // by handleParentQuotaChange (see line ~1704).
    if (updates && 'projectName' in updates && !this.props.id) {
      this.setState((prev: any) => {
        const oldProjectName = (prev.projectName || '');
        const newProjectName = (updates.projectName || '');
        // Only cascade if the prefix actually changed. We INTENTIONALLY allow the
        // empty -> non-empty transition: if the PM typed a suffix before the parent
        // name (so a row was stored as `_${shortName}_${suffix}`), the first keystroke
        // of the parent name matches `_${shortName}_` as the old prefix and recovers
        // the row to `${newProjectName}_${shortName}_${suffix}`. Rows with empty
        // childProjectName fall into neither match branch below, so they remain safe.
        if (oldProjectName === newProjectName) {
          return updates;
        }
        const prevChildStates = prev.childStates || {};
        let mutated = false;
        const nextChildStates: Record<string, any> = { ...prevChildStates };
        for (const key of Object.keys(prevChildStates)) {
          const row = prevChildStates[key];
          if (!row) continue;
          const shortName = row.shortName;
          if (!shortName) continue;
          const { base: oldBase, prefix: oldPrefix } = childProjectNameParts(oldProjectName, shortName);
          // Not trimmed: the suffix may legitimately end in a space the PM is
          // still typing, and re-prefixing must preserve it verbatim.
          const current = row.childProjectName || '';
          let nextValue: string | null = null;
          if (current === oldBase) {
            // Bare base prefix, no suffix — rewrite to new base.
            nextValue = composeChildProjectName(newProjectName, shortName, '');
          } else if (current.startsWith(oldPrefix)) {
            // Has a suffix — preserve it (spaces included).
            const suffix = current.substring(oldPrefix.length);
            nextValue = composeChildProjectName(newProjectName, shortName, suffix);
          }
          // else (empty OR legacy/mismatched): leave untouched.
          if (nextValue !== null && nextValue !== current) {
            nextChildStates[key] = { ...row, childProjectName: nextValue };
            mutated = true;
          }
        }
        return mutated ? { ...updates, childStates: nextChildStates } : updates;
      }, cb);
      return;
    }
    this.setState(updates, cb);
  };

  /**
   * Update a quota field on the parent and cascade to all children
   * that haven't explicitly overridden it.
   */
  handleParentQuotaChange = (field: string, value: any) => {
    // During CREATE mode, do NOT cascade point/quota fields to children.
    // Children should start at 0 (from DEFAULT_CHILD_STATE) and be set
    // manually per-child by the PM. Only cascade during UPDATE (edit) mode.
    const pointFields = ['ceggPoints', 'overquota', 'terminate', 'qualityterminate'];
    const isCreateMode = !this.props.id;
    if (isCreateMode && pointFields.includes(field)) {
      this.setState({ [field]: value });
      return;
    }

    this.setState((prev: any) => {
      const childStates = { ...prev.childStates };
      Object.keys(childStates).forEach((k) => {
        const child = childStates[k];
        if (!(child.overriddenFields || []).includes(field)) {
          childStates[k] = { ...child, [field]: value };
        }
      });
      return { [field]: value, childStates };
    });
  };

  // ==================== RENDER ====================

  render() {
    const { answersFields, selectedCountryOption, childStates, activeTab } = this.state;

    // Build tab list: Parent + per-child country tabs + Partners.
    // Keyed by the childStates key (child.id for saved, `new:<sn>[:nonce]` for
    // unsaved) so same-market duplicates each get a unique tab. Labels suffix
    // duplicates with " 2", " 3", ... in createdAt order: first AU = "AU",
    // second = "AU 2".
    const childKeyFor = (opt: any) => this.childStateKey(opt);
    const optsByShortName: Record<string, any[]> = {};
    selectedCountryOption.forEach((opt: any) => {
      const sn = opt.shortName;
      if (!sn) return;
      if (!optsByShortName[sn]) optsByShortName[sn] = [];
      optsByShortName[sn].push(opt);
    });
    Object.keys(optsByShortName).forEach((sn) => {
      // Sort each shortName group by createdAt ascending so the oldest child
      // keeps the plain "AU" label and later duplicates get " 2", " 3", ...
      optsByShortName[sn].sort((a: any, b: any) => {
        const at = a.createdAt ? new Date(a.createdAt).valueOf() : Number.MAX_SAFE_INTEGER;
        const bt = b.createdAt ? new Date(b.createdAt).valueOf() : Number.MAX_SAFE_INTEGER;
        return at - bt;
      });
    });
    const segmentIndexByKey: Record<string, number> = {};
    Object.values(optsByShortName).forEach((group: any[]) => {
      group.forEach((opt, idx) => { segmentIndexByKey[childKeyFor(opt)] = idx; });
    });
    const allCountryTabs = selectedCountryOption.map((opt: any) => {
      const key = childKeyFor(opt);
      const idx = segmentIndexByKey[key] || 0;
      const label = idx === 0 ? `${opt.shortName}` : `${opt.shortName} ${idx + 1}`;
      return {
        key: `child-${key}`,
        childKey: key,
        label,
        shortName: opt.shortName,
        countryName: opt.label,
      };
    });

    // Child-open display scoping (product decision — Option b): when the modal
    // was opened on a CHILD survey (this.state.data.parentid set), show ONLY the
    // opened child's tab — not its siblings (different-country or same-country
    // duplicates). We still loaded all siblings above (Bug A) so the suffix-label
    // ranking is correct (e.g. the opened "IN 2" child still computes idx=1 →
    // "IN 2", not "IN"); we just FILTER the rendered list down to the opened
    // child. The opened child's tab is the one whose childKey === this.props.id
    // (saved children key by their own survey UUID, which is this.props.id).
    //
    // Parent-open is UNCHANGED: data.parentid is null there, so the filter is
    // skipped and all child tabs render. (The gate is essential — on parent-open
    // this.props.id is the parent id, which is not a child tab key, so an
    // ungated filter would blank the tab strip.)
    //
    // Defensive: if the opened child somehow isn't in the computed list, fall
    // back to the full set rather than render zero tabs.
    const openedChildId = this.props.id;
    const isChildOpen = !!((this.state.data as any) && (this.state.data as any).parentid);
    let countryTabs = allCountryTabs;
    if (isChildOpen && openedChildId) {
      const onlyOpened = allCountryTabs.filter((t: any) => t.childKey === openedChildId);
      if (onlyOpened.length > 0) {
        countryTabs = onlyOpened;
      }
    }

    // Countries multiselect (Project Setup) value — scoped to the opened child
    // in child-open mode so it shows ONLY that child's country, not siblings.
    // Routed through the same effective-set source of truth as validation and
    // the submit payload. Parent-open/create: full set (unchanged). Label-rank
    // (allCountryTabs above) still uses the full selectedCountryOption.
    const countriesFieldValue = this.getEffectiveCountryOptions();

    return (
      <Modal
        centered
        size="xl"
        backdrop="static"
        onHide={this.props.onClose}
        show={this.props.show}
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.id ? 'Edit Survey' : 'Create Survey'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto', paddingTop: '0' }}>
          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <form onSubmit={this.props.handleSubmit(() => this.onSubmit())} noValidate>
            <Tab.Container activeKey={activeTab} onSelect={(k: any) => this.setState({ activeTab: k })}>
              {/* Tab Navigation */}
              <Nav variant="tabs" style={{
                position: 'sticky',
                top: 0,
                backgroundColor: '#fff',
                zIndex: 1202,
                borderBottom: '1px solid #dee2e6',
                paddingTop: '5px',
              }}>
                <Nav.Item>
                  <Nav.Link eventKey="parent">
                    <strong>Project Setup</strong>
                  </Nav.Link>
                </Nav.Item>
                {countryTabs.map((tab: any) => (
                  <Nav.Item key={tab.key}>
                    <Nav.Link eventKey={tab.key}>
                      {isPanelCountry(tab.shortName)
                        ? <>{tab.label} <span className="badge badge-primary" style={{ fontSize: '9px' }}>panel</span></>
                        : tab.label
                      }
                    </Nav.Link>
                  </Nav.Item>
                ))}
                <Nav.Item>
                  <Nav.Link eventKey="partners">Partners</Nav.Link>
                </Nav.Item>
                {!!this.props.id && !!(this.state.data as any)?.parentid && countryTabs.some((t: any) => isPanelCountry(t.shortName)) && (
                  <Nav.Item>
                    <Nav.Link eventKey="samples">Samples</Nav.Link>
                  </Nav.Item>
                )}
              </Nav>

              {/* Tab Content */}
              <Tab.Content>
                {/* Parent Tab */}
                <Tab.Pane eventKey="parent">
                  <ParentProjectTab
                    state={this.state}
                    setState={this.setParentState}
                    countries={this.state.countries}
                    selectedCountryOption={countriesFieldValue}
                    onCountryChange={this.handleCountryChange}
                    clientOptions={this.state.clientOptions}
                    pmData={this.state.pmData}
                    options={this.state.options}
                    selectedSurveyOptionss={this.state.selectedSurveyOptionss}
                    isEditMode={!!this.props.id}
                    onQuotaChange={this.handleParentQuotaChange}
                    childStates={childStates}
                    childTabs={countryTabs}
                    onChildFieldChange={this.updateChildField}
                  />
                </Tab.Pane>

                {/* Child Country Tabs */}
                {countryTabs.map((tab: any) => {
                  const childState = childStates[tab.childKey] || { ...DEFAULT_CHILD_STATE, country: tab.countryName, shortName: tab.shortName };
                  // Ask 4 — saved children expose a UUID via childState.id; unsaved
                  // (`new:<sn>:<nonce>`) keys never have one, so the pool-stats fetch
                  // and the upload-result lookup are gated on this prop being truthy.
                  const savedChildId = childState && childState.id ? String(childState.id) : undefined;
                  const lastUploadResultForChild = savedChildId
                    ? (this.state.lastUniqueLinksUploadResults || {})[savedChildId]
                    : undefined;
                  return (
                    <Tab.Pane key={tab.key} eventKey={tab.key}>
                      <ChildSurveyTab
                        childState={childState}
                        parentState={this.state}
                        countryName={tab.countryName}
                        shortName={tab.shortName}
                        instanceKey={tab.childKey}
                        childId={savedChildId}
                        uniqueLinksUploadResult={lastUploadResultForChild}
                        onChange={(field: string, value: any) => this.updateChildField(tab.childKey, field, value)}
                        isEditMode={!!this.props.id}
                        // Same source as PartnersTab's isParentSurvey (:2078 below) — both
                        // key off whether Form.tsx is editing the parent project or was
                        // opened directly on a child's own id (isChildOpen, computed above).
                        isParentSurvey={!isChildOpen}
                        preScreenSection={
                          <PreScreeningSection
                            shortName={tab.shortName}
                            instanceKey={tab.childKey}
                            preQuestionsYN={childState.preQuestionsYN}
                            onTogglePreScreen={(e: any) => this.handleChildTogglePrescreen(tab.childKey, e)}
                            preScreenOptions={this.state.preScreenOptions}
                            selectedPreScreenQues={childState.selectedPreScreenQues || []}
                            onPreScreenQuestionsChange={(selected: any[]) => this.handleChildPreScreenQuestions(tab.childKey, selected)}
                            submittedAnswerDets={childState.submittedAnswerDets || []}
                            onUpdateAnswer={(info: any, index: number) => this.openChildPreScreenAnswerModal(tab.childKey, info, index)}
                          />
                        }
                      />
                    </Tab.Pane>
                  );
                })}

                {/* Partners Tab */}
                <Tab.Pane eventKey="partners">
                  <PartnersTab
                    isEditMode={!!this.props.id}
                    parentSurveyId={this.props.id}
                    projectName={this.state.projectName || this.state.name}
                    surveyType={this.state.surveyType}
                    userLimitCommitted={this.state.userLimitCommitted}
                    childCountries={(this.state.selectedCountryOption || []).map((o: any) => ({
                      ...o,
                      // Enrich each market option with childProjectName so the partner
                      // modal can disambiguate same-country duplicates (id is already
                      // present on saved children — the selectedMarkets token). Source
                      // is childStates[childStateKey(opt)].childProjectName.
                      childProjectName: (this.state.childStates[this.childStateKey(o)] || {}).childProjectName || '',
                    }))}
                    isParentSurvey={!(this.state.data as any)?.parentid}
                    survey={this.state.data}
                  />
                </Tab.Pane>

                {/* Samples Tab — child-survey edit only (has parentid), at least one panel country.
                    Parent-survey edits and create mode do NOT show Samples. */}
                {!!this.props.id && !!(this.state.data as any)?.parentid && countryTabs.some((t: any) => isPanelCountry(t.shortName)) && (
                  <Tab.Pane eventKey="samples">
                    <SurveySamplesTab
                      parentSurveyId={this.props.id}
                      panelCountries={countryTabs
                        .filter((t: any) => isPanelCountry(t.shortName))
                        .map((t: any) => ({
                          shortName: t.shortName,
                          countryName: t.countryName,
                          childSurveyId: (childStates[t.childKey] as any)?.id,
                        }))
                      }
                    />
                  </Tab.Pane>
                )}
              </Tab.Content>
            </Tab.Container>

            {/* Pre-screening modals (shared across all tabs) */}
            {this.renderPreScreenModals()}

            <hr />

            <Alert variant="danger" show={!!this.state.error} className="mt-2">
              {this.state.error}
            </Alert>

            <div className="d-flex align-items-center mt-2">
              <button
                type="submit"
                disabled={!this.state.projectName}
                className="btn btn-primary mr-3"
              >
                Submit
              </button>
              <button
                type="button"
                onClick={() => this.reset()}
                className="btn btn-light mr-3"
              >
                Reset
              </button>
              <Show when={this.state.status === PageStatus.Submitting}>
                <Spinner animation="border" variant="primary" />
              </Show>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }

  // ==================== PRE-SCREEN MODALS ====================

  renderPreScreenModals() {
    const { answersFields } = this.state;

    return (
      <>
        {/* Add New Option Modal */}
        <Modal
          centered size="lg" backdrop="static"
          onHide={this.onCloseAddAnsModalFunc}
          show={this.state.formType === 'NEWOPTION'}
          style={{ zIndex: 1201, background: 'rgba(0, 0, 0, 0.3)' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add New Option</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
            <Show when={this.state.status === PageStatus.Loading}>
              <div className="d-flex justify-content-center w-100 p-5"><Spinner animation="border" variant="primary" /></div>
            </Show>
            <Alert variant="danger" show={this.state.status === PageStatus.Error}>{this.state.error}</Alert>
            <Show when={this.state.status !== PageStatus.Loading}>
              <div>
                <div className="row mt-2">
                  {answersFields?.map((ele: any, index: number) => (
                    ele.name === 'Range' ? (
                      <div className="col p-3" key={'abcd' + index}>
                        <div className="input-group">
                          <input className="form-control mx-1" name={ele.name}
                            onChange={(e) => this.setInputValueInArr(ele.lable, e, index, 'fromValue')}
                            onBlur={() => this.checkValidationNumber(null, index, 'fromValue')}
                            value={ele.fromValue} type="text" placeholder="From" required />
                          <input className="form-control mx-1" name={ele.name}
                            onChange={(e) => this.setInputValueInArr(ele.lable, e, index, 'toValue')}
                            onBlur={() => this.checkValidationNumber(null, index, 'toValue')}
                            value={ele.toValue} type="text" placeholder="To" required />
                        </div>
                      </div>
                    ) : (
                      <div className="col p-3" key={'abcde' + index}>
                        <label htmlFor="body">Answer {answersFields.length > 1 ? index + 1 : ''}*</label>
                        <div className="input-group">
                          <input className="form-control" type="text" value={ele.value}
                            onChange={(e) => this.setInputValueInArr(ele.lable, e, index, 'value')}
                            placeholder={`Enter answer ${answersFields.length > 1 ? index + 1 : ''}`} required />
                        </div>
                      </div>
                    )
                  ))}
                </div>
                <div className="d-flex align-items-center mt-2">
                  <button onClick={() => this.addNewOptionToSelectedQue()} className="btn btn-primary">Add</button>
                </div>
              </div>
            </Show>
          </Modal.Body>
        </Modal>

        {/* Add Quota Points Modal */}
        <Modal
          centered size="lg" backdrop="static"
          onHide={this.onCloseAddAnsModalFunc}
          show={this.state.formType === 'ADDQUOTAPOINTS'}
          style={{ zIndex: 1201, background: 'rgba(0, 0, 0, 0.3)' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Quota</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
            <Show when={this.state.status === PageStatus.Loading}>
              <div className="d-flex justify-content-center w-100 p-5"><Spinner animation="border" variant="primary" /></div>
            </Show>
            <Alert variant="danger" show={this.state.status === PageStatus.Error}>{this.state.error}</Alert>
            <Show when={this.state.status !== PageStatus.Loading}>
              <div>
                <div className="row mt-2">
                  <div className="col">
                    <label htmlFor="quotaPoints">Enter Quota</label>
                    <input className="form-control mx-1" name="quotaPoints"
                      onChange={(e) => this.setQuotaPointsToPreScreenQue(e)}
                      value={this.state.questionQuotaPoints} type="text" placeholder="Enter quota" required />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                  <button onClick={() => this.addQuotaPointsToPreScreenQue()} className="btn btn-primary">Add</button>
                </div>
              </div>
            </Show>
          </Modal.Body>
        </Modal>

        {/* Select/Update Answer Modal */}
        <Modal
          centered size="lg" backdrop="static"
          onHide={this.onCloseModalFunc}
          show={this.state.formType === 'UPDATE'}
          style={{ zIndex: 1201, background: 'rgba(0, 0, 0, 0.3)' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Answer</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
            <Show when={this.state.status === PageStatus.Loading}>
              <div className="d-flex justify-content-center w-100 p-5"><Spinner animation="border" variant="primary" /></div>
            </Show>
            <Alert variant="danger" show={this.state.status === PageStatus.Error}>{this.state.error}</Alert>
            <Show when={this.state.status !== PageStatus.Loading}>
              {this.state.selectedPreScreenQueDet?.label && (
                <div>
                  <div className="row mt-2">
                    <div className="col">
                      <label>{this.state.selectedPreScreenQueDet?.label}</label>
                      {this.state.selectedPreScreenQueDet?.answers?.map((e: any, index: number) => (
                        this.state.selectedPreScreenQueDet.questionType !== 'Range' ? (
                          <div className="col ml-2" key={'questionType' + index}>
                            <input type="checkbox" id={`prescreen-${index}`} name={`prescreen-${index}`}
                              checked={this.state.selectedPreScreenQueDet?.selectedAnsArr?.some((e1: any) => e1.answer === e && e1.mark === 'y')}
                              className="custom-control-input"
                              onChange={(evt) => this.handleAnswerChange(evt, e, this.state.selectedPreScreenQueDet?.value, 'checkbox')} />
                            <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className="text-lg">{e}</span></label>
                            {this.state.selectedPreScreenQueDet?.selectedAnsArr?.some((e1: any) => e1.answer === e && e1.mark === 'y') && (
                              <span className="ml-2">
                                <button className="bg-transparent" onClick={() => this.addQuotaPointsToAns(e, index)}>
                                  <em className={`fa fa-plus text-${parseInt(this.state.selectedPreScreenQueDet.selectedAnsArr.filter((ele: any) => ele.answer === e)[0]?.questionQuotaPoints) > 0 ? 'success' : 'warning'} cursor-pointer custom-control-icon`} title="Add quota" />
                                </button>
                              </span>
                            )}
                          </div>
                        ) : (
                          <div className="col ml-2" key={'questionType' + index}>
                            <input type="checkbox" id={`prescreen-${index}`} name={`prescreen-${index}`}
                              checked={this.state.selectedPreScreenQueDet?.selectedAnsArr?.some((sv: any) => sv.answer.fromValue === e.fromValue && sv.answer.toValue === e.toValue)}
                              className="custom-control-input"
                              onChange={(evt) => this.handleAnswerChange(evt, e, this.state.selectedPreScreenQueDet?.value, 'Range')} />
                            <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className="text-lg">{e.fromValue}-{e.toValue}</span></label>
                            {this.state.selectedPreScreenQueDet?.selectedAnsArr?.some((sv: any) => sv.answer.fromValue === e.fromValue && sv.answer.toValue === e.toValue) && (
                              <span className="ml-2">
                                <button className="bg-transparent" onClick={() => this.addQuotaPointsToAns(e, index)}>
                                  <em className={`fa fa-plus text-${parseInt(this.state.selectedPreScreenQueDet.selectedAnsArr.filter((sv: any) => sv.answer.fromValue === e.fromValue && sv.answer.toValue === e.toValue)[0]?.questionQuotaPoints) > 0 ? 'success' : 'warning'} cursor-pointer custom-control-icon`} title="Add quota" />
                                </button>
                              </span>
                            )}
                          </div>
                        )
                      ))}
                    </div>
                  </div>
                  <Alert variant="danger" show={this.state.status === PageStatus.Error} className="mt-2">{this.state.error}</Alert>
                  <div className="d-flex align-items-center mt-2">
                    <button onClick={() => this.addMoreOption(this.state.selectedPreScreenQueDet)} className="btn btn-success mr-3">Add New Option</button>
                    <button onClick={() => this.onFormUpdate(this.state.selectedPreScreenQueDet)} className="btn btn-primary mr-3">Submit</button>
                    <button onClick={() => this.onCloseModalFunc()} className="btn btn-light mr-3">Cancel</button>
                    {this.state.status === PageStatus.Submitting && <Spinner animation="border" variant="primary" />}
                  </div>
                </div>
              )}
            </Show>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const dataFormRedux = reduxForm<FormValue, any>({
  form: 'dataForm',
})(Form);

const mapStateToProps = (state: any) => ({
  selectedCountry: state.adminUser.adminUser.selectedCountry,
});

const dataFormWithRouter = withRouter(connect(mapStateToProps)(dataFormRedux));

export { dataFormWithRouter as Form };
